<template>
    <transition name="el-fade-in-linear">
      
      	<div>
		  	  <!-- 商品详情信息窗口 -->
			  <div class="backborder2" v-loading="addquery.loading">
			  	  <input type="file" id="coverthumb" @change="uploadfiles($event)" style="display:none"/>
				  <input type="file" id="bannerthumb" @change="uploadallfiles($event)" multiple style="display:none"/>
				  <input type="file" id="bannerthumb1" @change="uploadallfiles1($event)" multiple style="display:none"/>

			  	  <div style="width:100%;margin:20px 10px 30px 0;text-align:right">
					  <span style="float:left;font-size:15px">{{pushinfoname}}</span>
					  <el-button size="small" type="primary" @click="createSave">保 存</el-button>
					  <!-- 待用
					  <el-badge :value="drafsnums > 0 ? drafsnums : ''" class="item">
					  <el-button size="small" type="warning" @click="checkdraft">查看草稿</el-button>
					  </el-badge>
					  -->
				  </div>

				  <div class="add-goods-new">
				  	<div class="add-goods-cover-info-news">
					  <span class="add-goods-cover-info-news-span">封面图片</span>
					  <a class="add-goods-img-thumb" @click="addcoverthumb"  @mouseenter="showimgs(addquery.thumb)" @mouseleave="closimg"><img :src="addquery.thumb!='' && addquery.thumb!=null ? addquery.thumb : require('../../static/images/upload.png') " /></a>
					</div>
					<div class="add-goods-cover-info-news" style="border-bottom:1px solid #EBEEF5;margin-bottom:50px;">
					  <div class="add-goods-cover-info-news-span" style="display:flex;align-items:center;">
					  	  <div style="float:left;">商品主图</div>
						  <el-tooltip class="item" effect="dark" content="可对图片拖拽进行排序" placement="top">
						  <div style="float:left;width:15px;height:15px;font-size:12px;line-height:12px;display:flex;justify-content:center;align-items:center;border-radius:50%;color:#fff;margin-left:5%;background:#e6a23c;">?</div>
					  	  </el-tooltip>
					  </div>
					  <div class="add-goods-img-lists" :style="changesortcolor">
					  	 <a class="add-goods-img-thumb1"><img :src="require('../../static/images/upload.png')" @click="addbannerthumb"/></a>
						 
						 <div style="width:100%">
						 <draggable :list="addquery.banner" :move="getdata" @update="datadragEnd" :options="{animation: 200,handle:'.dargDiv'}">
							<transition-group name="list-complete">
								<div class="add-goods-img-thumb1 dargDiv" v-for="(item,index) in addquery.banner" :key="index" @mousedown="pressimg">
									<a class="add-goods-img-close" @click.stop="delbanner(index)"></a>
									<img :src="item.url" />
								</div>
							</transition-group>
						 </draggable>
						 </div>

					  </div>
					</div>
				  	<div class="add-goods-left">
						<el-form size="mini" :model="addquery" :rules="rules" ref="form" label-width="120px">
							<el-form-item >
								<div class="add-jdgoods-label" v-if="addquery.agentid==100000">
									<div class="add-jdgoods-label-info">JD 京东商品</div>
									<el-button size="small" v-if="addquery.packing!='' && addquery.packing!=null" @click="showpackingDialog=true" style="float:left;margin-left:2%">包装信息</el-button>
								</div>
							</el-form-item>
							<el-form-item label="所属品牌" prop="brandid" label-width="120" v-if="query.datacenter!='cz'" v-loading="sysbrandloading">
								<el-select v-model="addquery.brandid" clearable remote  filterable placeholder="请选择品牌" @change="createDrafsgoods">	            
									<el-option v-for="(item,index) in sysbrandlists" :label="item.showlable" :value="item.id" :key="index">
										<span style="float: left">{{item.name}}</span>
										<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
									</el-option>              
								</el-select>
								<el-button type="primary" circle size="mini" icon="el-icon-refresh" @click="getsysbrands"></el-button>
							</el-form-item>
							<el-form-item label="商品sku" label-width="120">
								<el-input v-model="addquery.spu" style="width:70%" :disabled="query.datacenter=='cz' || wangdian_sid ? true : false"  @blur="changegoodsspu" @change="createDrafsgoods"/>
							</el-form-item>
							<!--
							<el-form-item label="条形码" label-width="120" v-loading="barcodeloading">
								<el-input v-model="addquery.barcode" style="width:70%" :disabled="query.datacenter=='cz' ? true : false"  @blur="changegoodsbarcode" @change="createDrafsbarcode"/>
							</el-form-item>
							-->
							<el-form-item label="商品名称" prop="name" label-width="120" >
								<el-input v-model="addquery.name" style="width:70%" @blur="changegoodsspu" @change="createDrafsgoods"/>
							</el-form-item>
							<el-form-item label="默认规格" label-width="120">
								<el-input v-model="addquery.spec" style="width:70%" @blur="changegoodsspu" @change="createDrafsgoods"/>
							</el-form-item>
							<el-form-item label="商品品类" prop="pettype" label-width="120">
								<el-select v-model="addquery.pettype" placeholder="请选择" @change="createDrafsgoods">
									<el-option label="狗狗" value="1"></el-option>
									<el-option label="猫猫" value="2"></el-option>
									<el-option label="猫狗通用" value="4"></el-option>
									<el-option label="小宠" value="3"></el-option>
									<el-option label="其它" value="9"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="商品分类" prop="catid" label-width="120">
		                    	<el-cascader :options="mallcategorylist" v-model="addquery.catid"  @change="createDrafsgoods" />
		            		</el-form-item>
							<el-form-item label="国外品牌" label-width="120">
								<el-select v-model="addquery.isforeight" placeholder="请选择"  @change="createDrafsgoods">
									<el-option v-for="(item,index) in internals" :key="index" :label="item.name" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="批发价格" prop="sellprice" label-width="120">
								<el-input v-model="addquery.sellprice" style="width:50%" @blur="changegoodsspu" @change="createDrafsgoods"><template slot="append">元</template></el-input>
							</el-form-item>
							<el-form-item label="零售价格" label-width="120">
								<el-input v-model="addquery.marketprice" style="width:50%"  @change="createDrafsgoods"><template slot="append">元</template></el-input>
							</el-form-item>
							<el-form-item label="运费模板" label-width="120" v-loading="shippingtemploading">
								<el-select v-model="addquery.shipping_tempidid" placeholder="请选择"  @change="createDrafsgoods">
									<el-option v-for="(item,index) in shippingtemplists" :key="index" :label="item.name" :value="item.id"></el-option>
								</el-select>
								<el-button type="primary" circle size="mini" icon="el-icon-refresh" @click="getshippingtemplists"></el-button>
							</el-form-item>
						</el-form>  
					</div>
					<div class="add-goods-right">
						<div style="float:left;width:100%;padding:5px 0 5px 5px;border-bottom:1px dashed #666666">
							<el-form :inline="true" size="small">
								<el-form-item key="localgoods" v-if="localselectgoods.id > 0 && query.datacenter=='cz'">
									<el-input type="text" v-model="localselectgoods.name" :disabled="true"/>
								</el-form-item>
								<!--
								<el-form-item key="localunit" v-if="localselectgoods.unitid > 0 && query.datacenter=='cz'">
									<el-select v-model="localselectgoods.unitid" filterable>
										<el-option v-for="(item,index) in localselectgoods.unitlists" :label="item.unit" :value="item.id" :key="index"></el-option>
									</el-select>
								</el-form-item>
								-->
								<el-form-item key="localunitid" v-if="localselectgoods.unitid > 0 && query.datacenter=='cz'">
									<el-button type="success" size="mini" circle icon="el-icon-check" @click="addpropertyunionunit" />
								</el-form-item>
								<el-form-item>
									<el-button type="primary" size="mini" circle icon="el-icon-search" @click="getpropertygoods" v-if="query.datacenter=='cz'"/>
									<!--
									<el-tooltip class="item" effect="dark" placement="top" v-if="query.datacenter=='cz'">
									<div slot="content">刷新条形码，如条形码刷新无效时，请检查本<br/>地相应的商品里是否填写了条形码</div>
									<el-button type="primary" size="mini" circle icon="el-icon-refresh" @click="freshbarcode" v-if="query.datacenter=='cz'"></el-button>
									</el-tooltip>
									-->
									<el-button type="danger" size="mini" circle icon="el-icon-plus" @click="addpropertyinfos" v-if="query.datacenter!='cz'"/>
								</el-form-item>
							</el-form>

							<div class="add-jdgoods-label" v-if="addquery.agentid==100000">
					  		<div class="add-jdgoods-label-notice">注：京东商品信息的库存不在宠赞系统中，此处不展示</div>
					    	</div>
						</div>

						<el-table :data="addquery.property" class="goods-create-infos" size="mini">
							<el-table-column label="图片" align="center" width="70" fixed :render-header="renderHeader">
								<template slot-scope="scope">
									<div class="float:left;">
										<a class="add-goods-property-imgs" @mouseenter="showimgs(scope.row.img)" @mouseleave="closimg" @click="addpropertythumb(scope.$index)">
										  <img :src="scope.row.img!='' && scope.row.img!=null ? scope.row.img : require('../../static/images/no-img-2.jpg')"/>
										</a>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="sku" align="center" width="150" fixed :render-header="renderHeader">
								<template slot-scope="scope">
									<el-input size="small" v-model="scope.row.sku" :disabled="query.datacenter=='cz' || wangdian_sid ? true : scope.row.first==1 ? true : false" @change="createDrafsgoods"/>
								</template>
							</el-table-column>
							<!--
							<el-table-column label="条形码" align="center" width="150" fixed>
								<template slot-scope="scope">
									<el-input size="small" v-model="scope.row.barcode" :disabled="query.datacenter=='cz' ? true : scope.row.first==1 ? true : false" @change="createDrafsbarcode" v-loading="barcodeloading"/>
								</template>
							</el-table-column>
							-->
							<el-table-column label="规格名称" align="center" width="150" fixed :render-header="renderHeader">
								<template slot-scope="scope">
									<el-input size="small" v-model="scope.row.property_name" @change="createDrafsgoods"/>
								</template>
							</el-table-column>
							<el-table-column label="规格属性" align="center" width="120">
								<template slot-scope="scope">
									<el-input size="small" v-model="scope.row.spec" @change="createDrafsgoods"/>
								</template>
							</el-table-column>
							<el-table-column label="价格" align="center" width="140" :render-header="renderHeader">
								<template slot-scope="scope">
									<el-input size="small" v-model="scope.row.property_price" @blur="changepropertyprice(scope.row)" @change="createDrafsgoods"><template slot="append">元</template></el-input>
								</template>
							</el-table-column>
							<el-table-column label="零售价" align="center" width="100" :render-header="renderHeader">
								<template slot-scope="scope">
									<el-input size="small" v-model="scope.row.market" @change="createDrafsgoods"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="重量（kg）" align="center" width="150" :render-header="renderHeader">
								<template slot-scope="scope">
									<el-input size="small" v-model="scope.row.weight" @change="createDrafsgoods"><template slot="append">kg</template></el-input>
								</template>
							</el-table-column>
							<el-table-column label="活动到手价" align="center" width="120">
								<template slot-scope="scope">
									<el-input size="small" v-model="scope.row.especially_price" @change="createDrafsgoods" />
								</template>
							</el-table-column>
							
							<!-- <el-table-column label="分销价格" align="center" width="120" v-if="issplit==true">
								<template slot-scope="scope">
									<el-input size="small" v-model="scope.row.cz_price" :disabled="scope.row.issplit ? false : true" /><template slot="append">元</template></el-input>
								</template>
							</el-table-column>
							<el-table-column label="分销设置" align="center" width="120" v-if="issplit==true">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" content="开关开启时，表示该规格的商品允许宠老板系统商家代为销售（分销），反之不允许" placement="top">
										<el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="scope.row.issplit" ></el-switch>
									</el-tooltip>
								</template>
							</el-table-column> -->
							
							<el-table-column label="有效期至" align="center" key="expire_at" prop="expire_at" width="150">
								<template slot-scope="scope">
									<el-date-picker
										style="width:130px"
										size="small"
										v-model="scope.row.expire_at"
										value-format="yyyy-MM-dd"
										type="date"
										placeholder="选择日期">
									</el-date-picker>
								</template>	
							</el-table-column>
							<el-table-column label="销售单位" align="center" key="unit" prop="unit" v-if="query.agentid!=100000 && query.datacenter=='cz'" width="120">
								<template slot-scope="scope">
									<span>{{scope.row.unit}}</span><br/>
									<a class="unit-select-style" @click="changepropertyunit(scope.row,scope.$index)">修改</a>
								</template>	
							</el-table-column>
							<el-table-column label="单位" align="center" key="noczunit" prop="unit" v-if="query.datacenter!='cz'" width="120">
								<template slot-scope="scope">
									<el-select v-model="scope.row.unit" filterable placeholder="请选择单位" size="small" @change="createDrafsgoods">
										<el-option v-for="(item,index) in noczunilists" :label="item.name" :value="item.name" :key="index"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="当前库存" align="center" width="120" key="inventory" v-if="query.agentid!=100000">
								<template slot-scope="scope">
									<el-input type="text" size="small" v-model="scope.row.inventory" :disabled="query.datacenter=='cz' || wangdian_sid ? true : false " @change="changeinventorys(scope.row)"/>
								</template>
							</el-table-column>
							<el-table-column label="冻结库存" align="center" width="120" key="useinventory" v-if="query.agentid!=100000">
								<template slot-scope="scope">
									<span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.useinventory}}</span>
								</template>
							</el-table-column>
							<el-table-column label="可用库存" align="center" width="120" key="lastinventory" v-if="query.agentid!=100000">
								<template slot-scope="scope">
									<span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.lastinventory}}</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" align="center" fixed="right">
								<template slot-scope="scope">
									<el-button type="danger" size="mini" icon="el-icon-delete" circle @click="delproperty(scope.row,scope.$index)"/>
								</template>
							</el-table-column>
						</el-table>
					</div>
				  </div>

				  
				  <!-- 发布到抖店数 -->
				  <!--
				  <div class="goods-create-douyin-infos" v-if="isdoudian==1">
				  	  <div class="goods-create-isdouyin-title">抖音店铺同步发布 / 修改设置<i>（最后一次同步时间：2021-12-03 12:30:25）</i></div>
				  	  <div class="goods-create-isdouyin-select">
						  <span class="goods-create-isdouyin-label">是否同步信息到抖店</span>	
					  	  <el-radio-group v-model="addquery.ispushdoudian" size="small" round style="inline-block;margin-left:10px">
							<el-radio-button label="否" />
							<el-radio-button label="是" />
						  </el-radio-group>
						  <el-tooltip content="Top center" placement="top">
  						  <div slot="content">当按钮选择是时，系统将对下面数据进行校验，最终将商品信息同步发布到抖音小店<br/>反之则忽略不发布到抖店</div>
						  <div class="goods-create-isdouyin-label goods-create-isdouyin-question">?</div>
						  </el-tooltip>
						  <div class="goods-create-isdouyin-btn" v-if="addquery.ispushdoudian=='是'">
						  	  <el-button type="" size="small" icon="el-icon-plus" round @click="addgoods_to_douyin_shop">添加要发布的抖店</el-button>
						  </div>
					  </div>
					  <div class="goods-create-isdouyin-lists-info-item" style="display:inline-block;float:none;width:100%;margin:40px 0 0 0" v-if="addquery.ispushdoudian=='是'">
						  <div class="goods-create-isdouyin-lists-info-itemtitles">抖店商品名称</div>
						  <div class="goods-create-isdouyin-lists-info-itemcontent" style="width:30%">
							  <el-input placeholder="请设置抖店商品名称" v-model="addquery.doudianname" clearable size="mini" />	
						  </div>
						  <el-tooltip content="Top center" placement="top">
  						  <div slot="content">商品名称最多请不要设置超过60个字符，<br/>否则可能导致抖店审核不通过</div>
						  <div class="goods-create-isdouyin-label goods-create-isdouyin-question">?</div>
						  </el-tooltip>
					  </div>
					  <div class="goods-create-isdouyin-lists-info-item" style="display:inline-block;float:none;width:100%;margin:20px 0 0 0" v-if="addquery.ispushdoudian=='是'">
						  <div class="goods-create-isdouyin-lists-info-itemtitles">抖店商品分类</div>
						  <div class="goods-create-isdouyin-lists-info-itemcontent" style="width:30%">
							  <el-input placeholder="请设置抖店商品分类" v-model="addquery.doudiancatname" clearable size="mini" @focus="getdshopgoodscate" />	
						  </div>
					  </div>

					  <div class="goods-create-isdouyin-lists-info-item" style="display:flex;align-items:center;float:none;width:100%;margin:20px 0 0 0" v-if="addquery.ispushdoudian=='是'">
						  <div class="goods-create-isdouyin-lists-info-itemtitles" style="display:flex;align-items:center">商品分类属性</div>
						  <div @click="showattributeinfos" class="goods-create-isdouyin-lists-info-itemcontent" style="width:30%;background:rgba(221,221,221,.3);border:1px dashed rgba(221,221,221,.7);border-radius:6px;padding:10px;color:#606266;font-size:13px;line-height:23px;cursor:pointer;min-height:30px;display:flex;align-items:center">
							  {{addquery.attribute!='' ? addquery.attribute : '您还没有选择属性'}}
						  </div>
					  </div>

					  <div class="goods-create-isdouyin-lists-info-item" style="width:100%;margin:20px 0 0 0" v-if="addquery.ispushdoudian=='是'">
						  <div class="goods-create-isdouyin-lists-info-itemtitles">抖店客服电话</div>
						  <div class="goods-create-isdouyin-lists-info-itemcontent">
						  <el-input placeholder="请设置抖店客服电话" v-model="addquery.doudianmobile" clearable size="mini" />	
						  </div>
					  </div>
					  <div class="goods-create-isdouyin-lists-info-item" style="width:100%;margin:20px 0 0 0" v-if="addquery.ispushdoudian=='是'">
						  <div class="goods-create-isdouyin-lists-info-itemtitles">抖店支付方式</div>
						  <div class="goods-create-isdouyin-lists-info-itemcontent">
							  <el-select v-model="addquery.doudianpaytype" filterable placeholder="请选择抖店付款方式" size="mini">
								  <el-option v-for="(item,index) in doudianpaytypelists" :label="item.name" :value="item.id" :key="index"></el-option>
							  </el-select>	
						  </div>
					  </div>
					  <div class="goods-create-isdouyin-lists-info-item" style="width:100%;margin:20px 0 0 0" v-if="addquery.ispushdoudian=='是'">
						  <div class="goods-create-isdouyin-lists-info-itemtitles">承诺发货时间</div>
						  <div class="goods-create-isdouyin-lists-info-itemcontent-wid06">
							  <el-select v-model="addquery.delivery_delay_day" filterable placeholder="请选择承诺发货时间" size="mini">
								  <el-option v-for="(item,index) in doudianpromisetime" :label="item.name" :value="item.id" :key="index"></el-option>
							  </el-select>
						  </div>
					  </div>
					  <div class="goods-create-isdouyin-lists-info-item" style="width:100%;margin:20px 0 0 0" v-if="addquery.ispushdoudian=='是'">
						  <div class="goods-create-isdouyin-lists-info-itemtitles">是否支持7天无理由退货</div>
						  <div class="goods-create-isdouyin-lists-info-itemcontent-wid04">
							  <el-select v-model="addquery.supply_7day_return" filterable placeholder="请选择是否支持7天无理由退货" size="mini">
								  <el-option v-for="(item,index) in supply_7day_return_lists" :label="item.name" :value="item.id" :key="index"></el-option>
							  </el-select>
						  </div>
					  </div>

					  <div class="goods-create-isdouyin-lists" v-if="addquery.ispushdoudian=='是'">
					  	  <div class="goods-create-isdouyin-lists-info" v-for="(tt,ii) in addquery.doudianinfos" :key="ii">
							  <div class="goods-create-isdouyin-lists-left">
							  	  <div class="goods-create-isdouyin-dshop">{{tt.dshopname}}</div>
								  <div class="goods-create-isdouyin-dshopid">店铺ID：{{tt.dshopid}}</div>		
							  </div>
							  <div class="goods-create-isdouyin-lists-center">
								  <div class="goods-create-isdouyin-verify-success" v-if="tt.update_status==1">同步成功</div>
								  <el-tooltip placement="top">
  								  <div slot="content">{{tt.update_error_reason}}</div>
								  <div class="goods-create-isdouyin-verify-error" v-if="tt.update_status==2">同步失败</div>
								  </el-tooltip>
								  <span style="float:left;font-size:13px;line-height:23px">sku：{{tt.sku}}</span>
								  <span style="float:left;font-size:13px;line-height:23px">（单位：{{tt.unit}}）</span>
							  </div>
							  <div class="goods-create-isdouyin-lists-right">
								  <div class="goods-create-isdouyin-lists-info-item">
								  	  <div class="goods-create-isdouyin-lists-info-itemtitles">售卖价格</div>
								  	  <div class="goods-create-isdouyin-lists-info-itemcontent">
										  <el-input placeholder="请设置售卖价格" v-model="tt.price" clearable size="mini"><template slot="prepend">￥</template></el-input>	
									  </div>
								  </div>
								  <div class="goods-create-isdouyin-lists-info-item">
								  	  <el-button type="danger" size="mini" circle  icon="el-icon-delete" @click="deldoudianspec(ii)" />
								  </div>
							  </div>
						  </div>
					  </div>
				  </div>
				  -->


				  <div style="float:left;width:100%;margin:30px 0">
				  	  <quill-editor v-model="addquery.content"
						ref="mycreateQuillEditor"
						:options="editorOption"
						v-loading="addquery.loading"
						@change="onEditorchange">
					  </quill-editor>
				  </div>

				  <div style="width:100%;margin:20px 10px 30px 0;text-align:right">
              		<el-button size="small" type="primary" @click="createSave">保 存</el-button>
          		  </div>
			</div>
		

		  
		  <!-- 规格选择商品信息 -->
		  <el-dialog title="选择商品信息" :visible.sync="propertygoodsDialog" top="5vh" width="60%">
		  	  <el-form :inline="true" size="small">
				<el-form-item style="width:15%" v-if="brandlists.length > 0">
					<el-select v-model="propertygoodsquery.brandid" clearable filterable  placeholder="请选择品牌" @change="propertygoodsquery.ischange=true">
						<el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
							<span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input type="text" v-model="propertygoodsquery.key" placeholder="商品名称 / sku / 商品编号 / 条形码" clearable @keyup.enter.stop.native="getpropertygoodsnewdata" @change="propertygoodsquery.ischange=true"/>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" icon="el-icon-search" circle @click="getpropertygoodsnewdata"/>
				</el-form-item>
			  </el-form>

			  <el-table :data="propertygoodslist" v-loading="propertygoodsquery.loading">
				<el-table-column label="id" align="left" prop="id" width="90"/>
				<el-table-column label="商品名称" align="left">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.name}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="sku" align="center" v-if="query.agentid==100000" width="170" key="sku">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.sku}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="京东销售价" align="center" v-if="query.agentid==100000" width="170" key="jdprice">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.jdprice}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="协议销售价" align="center" v-if="query.agentid==100000" width="170" key="price">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.price}}</span>
			        </template>
		        </el-table-column>
				<!--
				<el-table-column label="条形码" align="center" v-if="query.agentid < 100000" width="170" key="barcode" v-loading="barcodeloading">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.barcode}}</span>
			        </template>
		        </el-table-column>
				-->
				<el-table-column label="编号" align="center" v-if="query.agentid < 100000" width="170" key="number">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.number}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="批发价" align="center" v-if="query.agentid < 100000" width="170" key="sell">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.sell}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="零售价" align="center" v-if="query.agentid < 100000" width="170" key="market">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.market}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="操作" align="center" width="90" key="handle">
			        <template slot-scope="scope">
			            <el-button type="success" size="mini" icon="el-icon-check" circle @click="selectgoods(scope.row)"/>
			        </template>
		        </el-table-column>
			</el-table>
			<div class="block">
		        <!--分页begin-->
		        <el-pagination
		            @size-change="pagePropertySizeChange"
		            @current-change="pagePropertyCurrentChange"
		            :current-page="propertygoodsquery.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="propertygoodsquery.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="propertygoodsrows">
		        </el-pagination>
		        <!--分页end-->
	        </div>
		  </el-dialog>
		  
		  <!-- 展示图片大图 -->
		  <div :style="showimgclass" class="showbigimg">
		  	<img :src="showimgurl" style="max-width:90%;max-height:90%"/>
		  </div>

		  <!-- 京东包装信息 -->
		  <el-dialog title="包装信息" :visible.sync="showpackingDialog" top="5vh" width="40%">
			  <div class="add-goods-packing" v-if="addquery.packing!=''" key="packing">
				  <table class="specs" v-html="addquery.packing"></table>
			  </div>
			  <div slot="footer" class="dialog-footer">
              	  <el-button size="mini" @click="showpackingDialog = false">取 消</el-button>
          	  </div>
		  </el-dialog>

		  
		  <!-- 添加要发布的抖音店铺 -->
		  <el-dialog title="选择要发布到抖店的规格" :visible.sync="mydshopDialog" top="5vh" width="45%">
			  <el-table :data="mydshoplists" v-loading="mydshoploading">
				  <el-table-column label="抖店信息" align="left" prop="dshopid" min-width="120">
					  <template slot-scope="scope">
					  	  <div style="font-size:13px;line-height:21px;width:100%">{{scope.row.dshopname}}</div>
						  <div style="font-size:12px;line-height:21px;color:#999999;width:100%">抖店ID：{{scope.row.dshopid}}</div>
					  </template>
				  </el-table-column>
				  <el-table-column label="规格信息" align="left" width="120">
					  <template slot-scope="scope">
					  	  <div style="font-size:13px;line-height:21px;width:100%">{{scope.row.property_name}}</div>
						  <div style="font-size:12px;line-height:21px;color:#999999;width:100%">(sku：{{scope.row.sku}})</div>
					  </template>
				  </el-table-column>
				  <el-table-column label="单位" align="center" width="120">
					  <template slot-scope="scope">
					  	  <div style="font-size:13px;line-height:21px;width:100%">{{scope.row.unit}}</div>
					  </template>
				  </el-table-column>
				  <el-table-column label="售价" align="center" width="120">
					  <template slot-scope="scope">
					  	  <div style="font-size:13px;line-height:21px">{{scope.row.price}}</div>
					  </template>
				  </el-table-column>
				  <el-table-column label="操作" align="center" width="120">
					  <template slot-scope="scope">
					  	  <el-button :type="scope.row.isselect==0 ? '' : 'success'" size="small" round @click="scope.row.isselect==0 ? scope.row.isselect=1 : scope.row.isselect=0 ">{{scope.row.isselect==0 ? '选择规格' : '取消选择' }}</el-button>
					  </template>
				  </el-table-column>
			  </el-table>
			  <div slot="footer" class="dialog-footer">
              	  <el-button size="small" @click="mydshopDialog = false">取 消</el-button>
              	  <el-button size="small" type="primary" @click="savedshopspec">保 存</el-button>
          	  </div>
		  </el-dialog>


		  <!-- 抖店发布商品分类信息 -->
		  <el-dialog title="抖店商品分类信息" :visible.sync="doudiancateDialog" top="20vh" width="20%">
		  	  <div style="display:inline-block;width:100%" v-loading="doudiancateloading">
			  <div class="goods-create-isdouyin-lists-info-item" style="width:100%;margin:20px 0 0 0" v-if="doudiancatelists1.length > 0">
				  <div class="goods-create-isdouyin-lists-info-itemcontent">
					  <el-select v-model="doudiancate1" filterable placeholder="请选择一级分类" size="small" @change="getdshopgoodscatedata(1)">
						  <el-option v-for="(item,index) in doudiancatelists1" :label="item.name" :value="item.id" :key="index"></el-option>
					  </el-select>	
				  </div>
			  </div>
			  <div class="goods-create-isdouyin-lists-info-item" style="width:100%;margin:20px 0 0 0" v-if="doudiancatelists2.length > 0">
				  <div class="goods-create-isdouyin-lists-info-itemcontent">
					  <el-select v-model="doudiancate2" filterable placeholder="请选择二级分类" size="small" @change="getdshopgoodscatedata(2)">
						  <el-option v-for="(item,index) in doudiancatelists2" :label="item.name" :value="item.id" :key="index"></el-option>
					  </el-select>	
				  </div>
			  </div>
			  <div class="goods-create-isdouyin-lists-info-item" style="width:100%;margin:20px 0 0 0" v-if="doudiancatelists3.length > 0">
				  <div class="goods-create-isdouyin-lists-info-itemcontent">
					  <el-select v-model="doudiancate3" filterable placeholder="请选择三级分类" size="small" @change="getdshopgoodscatedata(3)">
						  <el-option v-for="(item,index) in doudiancatelists3" :label="item.name" :value="item.id" :key="index"></el-option>
					  </el-select>	
				  </div>
			  </div>
			  <div class="goods-create-isdouyin-lists-info-item" style="width:100%;margin:20px 0 0 0" v-if="doudiancatelists4.length > 0">
				  <div class="goods-create-isdouyin-lists-info-itemcontent">
					  <el-select v-model="doudiancate4" filterable placeholder="请选择四级分类" size="small" @change="getdshopgoodscatedata(4)">
						  <el-option v-for="(item,index) in doudiancatelists4" :label="item.name" :value="item.id" :key="index"></el-option>
					  </el-select>	
				  </div>
			  </div>
			  <div class="goods-create-isdouyin-lists-info-item" style="width:100%;margin:20px 0 0 0" v-if="doudiancatelists5.length > 0">
				  <div class="goods-create-isdouyin-lists-info-itemcontent">
					  <el-select v-model="doudiancate5" filterable placeholder="请选择五级分类" size="small">
						  <el-option v-for="(item,index) in doudiancatelists5" :label="item.name" :value="item.id" :key="index"></el-option>
					  </el-select>	
				  </div>
			  </div>
			  <div slot="footer" class="dialog-footer" style="display:inline-block;width:100%;text-align:right;margin-top:30px">
              	  <el-button size="small" @click="doudiancateDialog = false">取 消</el-button>
              	  <el-button size="small" type="primary" @click="savecatids">保 存</el-button>
          	  </div>
			  </div>
		  </el-dialog>


		  <!-- 抖店商品分类属性 -->
		  <el-dialog title="抖店商品分类属性" :visible.sync="dshopattributeDialog" top="5vh" width="30%">	
			  <div style="display:inline-block;width:100%" v-loading="dshopattributeloading">
			  	  <div class="dshop-name-cate-attributes" style="display:inline-block;width:100%;margin:5px 0" v-for="(item,index) in  attributelists" :key="index">
					  <div class="dshop-name-cate-attributes-isrequire" style="display:inline-block;font-size:15px;padding:5px;color:#F56C6C" v-if="item.isrequired==1">*</div>
					  <div class="dshop-name-cate-attributes-norequire" style="display:inline-block;font-size:15px;padding:5px;color:#fff" v-if="item.isrequired==2">*</div>
					  <div class="dshop-name-cate-attributes-name" style="display:inline-block;font-size:13px;color:#333">{{item.name}}</div>
				  	  <el-input type="text" v-model="item.value" clearable v-if="item.isshow==2" size="small" style="display:inline-block;width:60%;margin-left:1%"/>
				  	  <el-select v-model="item.value" filterable clearable v-if="item.isshow==1" size="small" style="display:inline-block;width:60%;margin-left:1%">
						  <el-option v-for="(tt,ii) in item.models" :label="tt" :value="tt" :key="ii"></el-option>
					  </el-select>	
				  </div>
			  </div>
			  <div slot="footer" class="dialog-footer" style="display:inline-block;width:100%;text-align:right;margin-top:30px">
              	  <el-button size="small" @click="dshopattributeDialog = false">取 消</el-button>
              	  <el-button size="small" type="primary" @click="saveattribute">保 存</el-button>
          	  </div>
		  </el-dialog>

		  
		  <!-- 草稿箱 -->
		  <div :class="opendrafs ? 'cz-mall-goods-mydrafs cz-mall-goods-mydrafs-open' : 'cz-mall-goods-mydrafs'">
			  <div class="cz-mall-goods-btn">
			  	  <el-button type="" size="small" round @click="opendrafs=false">取 消</el-button>
			  </div>

			  <div class="cz-mall-goods-mydrafs-lists" v-if="drafsnums > 0">
			  	  <div class="cz-mall-goods-mydrafs-infos" @click="catchdrafs(item)" v-for="(item,index) in draflists" :key="index">
					  <img src="../../assets/drafs.png" />
					  <div class="cz-mall-goods-mydrafs-infos-content">
						  <span class="name">{{item.note}}</span>
						  <span class="time">{{item.inputtime}}</span>
					  </div>
					  <a @click.stop="deldrafs(item,index)"><img src="../../assets/error.png" /></a>
				  </div>
				  <div class="cz-mall-goods-add-show-loading">
				  	  <el-button size="small" type="" :loading="drafquery.loading" @click="getpagedraflists">{{drafquery.addmore ? '获取更多草稿文件' : '没有更多草稿文件'}}</el-button>
				  </div>
			  </div>
		  
			  <div class="cz-mall-goods-nodrafs" v-if="drafsnums==0">
				  <div class="cz-mall-goods-nodrafs-empty">
				  	  <img src="../../assets/box_empty.png"/>
					  <span>草稿箱空了</span>
				  </div>
			  </div>
		  </div>


		  <!-- 选择销售单位 -->
		  <el-dialog title="选择销售单位" :visible.sync="propertyunitquery.dialog" top="5vh" width="400">	
				<el-table :data="propertyunitquery.lists" v-loading="propertyunitquery.loading">
				  <el-table-column label="ID" align="left" prop="id" min-width="120">
					  <template slot-scope="scope">
						  <div style="font-size:12px;line-height:21px;color:#666666;width:100%">{{scope.row.id}}</div>
					  </template>
				  </el-table-column>
				  <el-table-column label="单位" align="center" width="120">
					  <template slot-scope="scope">
					  	  <div style="font-size:13px;line-height:21px;width:100%">{{scope.row.unit}}</div>
					  </template>
				  </el-table-column>
				  <el-table-column label="批发价" align="center" width="120">
					  <template slot-scope="scope">
					  	  <div style="font-size:13px;line-height:21px">{{scope.row.sell}}</div>
					  </template>
				  </el-table-column>
				  <el-table-column label="零售价" align="center" width="120">
					  <template slot-scope="scope">
					  	  <div style="font-size:13px;line-height:21px">{{scope.row.market}}</div>
					  </template>
				  </el-table-column>
				  <el-table-column label="操作" align="center" width="120">
					  <template slot-scope="scope">
							<el-button type="success" circle icon="el-icon-plus" size="small" @click="selectunitadd(scope.row)"></el-button>
					  	  <el-button type="success" circle icon="el-icon-check" size="small" @click="selectunitinfos(scope.row)"></el-button>
					  </template>
				  </el-table-column>
			  </el-table>
		  </el-dialog>


		</div>
    </transition>
</template>


<script>

import { quillEditor } from 'vue-quill-editor'
import draggable from 'vuedraggable'
export default {
	props:['childdata'],
	components: {quillEditor,draggable},  
    data(){
	    return{
	        actionauth:'', //功能权限
	        transitionshow:true,
	        url:this.GLOBAL.domain+"Goods/index",
	        agentlists:[],
			query: {
				agentid:'',
				id:'',
				datacenter:'', //使用的数据中心（数据来源方式）
			},
			brandlists:[],
			addquery: {
				act:'savemallgoodsnew',
				token:this.$cookies.get('token'),
				loading:false,
				goodsid:'',
				productid:'',
				agentid:'',
				name:'',
				spec:'',
				pettype:'',
				catid:[],
				isforeight:'',
				sellprice:'',
				marketprice:'',
				thumb:'',
				packing:'',
				content:'',
				spu:'',
				brandid:'',
				shipping_tempidid:'',
				banner:[],
				property:[],
				bannnersort:0,
				ispushdoudian:'否',
				doudianname:'',
				doudiancatid:'',
				doudiancatname:'',
				attribute:'',
				attributecatid:'',
				doudianmobile:'',
				delivery_delay_day:2,
				supply_7day_return:0,
				doudianpaytype:1,
				doudianinfos:[],
				doudianinfos_model:[
					{productid:10981267,sku:'FCK028912',dshopid:25372195,dshopname:'人人宠',catid:'',catname:'宠物用品/干粮',price:150.00,delivery_delay_day:2,supply_7day_return:0,mobile:'18172344974'},
				],
			},
			mallcategorylist:[],
			internals:[
			  {value:1,name:'否'},
	      	  {value:2,name:'是'}
			],
			localselectgoods: {
				id:'',
				name:'',
				unitid:'',
				spec:'',
				sku:'',
				img:'',
				unitlists:[]
			},

			propertygoodsDialog:false,
			propertygoodsquery: {
				act:'getpropertygoodsnew',
				token:this.$cookies.get('token'),
				loading:false,
				ischange:false,
				id:'',
				agentid:'',
				key:'',
				brandid:'',
				p:1,
				rollpage:10
			},
			propertygoodslist:[],
			propertygoodsrows:0,
			showimgurl:'',
			showimgclass:{'left':'0','bottom':'0','width':'0','height':'0','z-index':'0','padding':'0','transition':'.3s all','border-top':'none','border-right':'none','border-bottom':'none','background':'#dddddd','border-radius':'none','overflow':'hidden'},
			openclass:{'position':'fixed','left':'0','bottom':'0','width':'350px','height':'350px','z-index':'100000','padding':'5px','transition':'.3s all','border-top':'1px solid #666666','border-right':'1px solid #666666','border-bottom':'1px solid #666666','background':'#dddddd','border-radius':'0 15px 15px 0','overflow':'hidden'},
			closeclass:{'position':'fixed','left':'0','bottom':'0','width':'0','height':'0','z-index':'0','padding':'0','transition':'.3s all','border-top':'none','border-right':'none','border-bottom':'none','background':'#dddddd','border-radius':'none','overflow':'hidden'},
			uploadsquery: {
				type:'',
				index:'',
			},
			showpackingDialog:false,
			editorOption: { //文本框功能配置
			  placeholder: '请输入内容',
			  modules: { // 配置富文本
				toolbar: {
					container: [
						/**
						['bold', 'italic', 'underline', 'strike'],
						['blockquote', 'code-block'],
						[{ 'header': 1 }, { 'header': 2 }],
						[{ 'direction': 'rtl' }],
						[{ 'size': ['small', false, 'large', 'huge'] }],
						[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
						[{ 'color': [] }, { 'background': [] }],
						[{ 'font': [] }],
						[{ 'align': [] }],
						['clean'],
						['link', 'image', 'video']
						*/
						['image']
					],
					handlers: {
						'image': function(value) {
							if(value) {
								document.getElementById('bannerthumb1').click();
							}else {
								this.quill.format('image', false);
							}
						}
					},
				},
			  }
		    },
			qilllength:0,
			imgnumber:0,
			noczunilists:[],
			pushinfoname:'',
			issplit:false,
			sysbrandlists:[],
			sysbrandloading:false,
			shippingtemplists:[],
			shippingtemploading:false,
			isdoudian:0,
			doudianpromisetime:[{id:2,name:'2天'},{id:3,name:'3天'},{id:5,name:'5天'},{id:7,name:'7天'},{id:10,name:'10天'},{id:15,name:'15天'}],
			supply_7day_return_lists:[{id:0,name:'不支持'},{id:1,name:'支持'},{id:2,name:'支持（拆封后不支持）'}],
			doudianpaytypelists:[{id:0,name:'货到付款'},{id:1,name:'在线支付'},{id:2,name:'货到付款+在线支付'}],
			
			mydshopDialog:false,
			mydshoploading:false,
			mydshoplists:[],

			doudiancateDialog:false,
			doudiancateloading:false,
			doudiancate1:'',
			doudiancate2:'',
			doudiancate3:'',
			doudiancate4:'',
			doudiancate5:'',
			doudiancate6:'',
			doudiancatelists1:[],
			doudiancatelists2:[],
			doudiancatelists3:[],
			doudiancatelists4:[],
			doudiancatelists5:[],
			doudiancatelists6:[],
			dshopattributeDialog:false,
			dshopattributeloading:false,
			attributelists:[],
			changesortcolor:{background:'#fff',border:'1px solid #fff'},
			opendrafs:false,

			drafquery: {
				act:'getdraflists',
				token:this.$cookies.get('token'),
				p:1,
				rollpage:10,
				addmore:true,
				loading:false,
			},
			draflists:[],
			drafsnums:0,

			propertyunitquery: {
				index:'',
				dialog:false,
				loading:false,
				productid:'',
				lists:[],
			},
			barcodeloading:false,
			currSKU: {},
			rules: {
				brandid: [ 
					{ required: true, message: '请选择所属品牌', trigger: 'change' }
				],
				spu: [ 
					{ required: true, message: '请输入商品SKU', trigger: 'blur' }
				],
				name: [ 
					{ required: true, message: '请输入商品名称', trigger: 'blur' }
				],
				pettype: [ 
					{ required: true, message: '请选择商品品类', trigger: 'change' }
				],
				catid: [
					{ required: true, type: 'array', message: '请选择商品分类', trigger: 'change' }
				],
				sellprice: [
					{ required: true, message: '请输入批发价格', trigger: 'blur' },
					{ 
					validator: (rule, value, callback) => {
						if (isNaN(value) || value <= 0) {
						callback(new Error('请输入有效数字'));
						} else {
						callback();
						}
					}, 
					trigger: 'blur' 
					}
				]
			},
			wangdian_sid: ''

	    }
	},
    
	mounted(){  
		var _this=this;
	    this.getactionauth();
		this.getmallCategoryList(); //获取线上商城的分类
		this.getagentcenter(); //获取代理商所使用的数据中心
		this.addquery.act=this.childdata.act;
		this.getnoczunilists(); //数据中心不在宠赞时默认获取系统的单位信息
		this.getSplitshow(); //获取是否有分销的权限
		this.getsysbrands(); //获取当前代理商品牌信息
		this.getshippingtemplists(); //获取运费模板信息

		this.checkdoudianauth(); //获取当前代理商是否有对接抖店数据权限
		this.getserverphones();  //获取线上商城客服电话

		//设置当前操作类型（发布商品/编辑商品）
		if(this.addquery.act=='savemallgoodsnew' || this.addquery.act=='noczsavemallgoodsnew') this.pushinfoname='新增商品信息';
		if(this.addquery.act=='editmallgoodsnew' || this.addquery.act=='noczeditmallgoodsnew') this.pushinfoname='编辑商品信息';
		//发布数据初始化
		this.getpushinfosstart();
		//获取草稿箱数量
		this.getdrafsnums();
		this.wangdian_sid = this.$cookies.get('wangdian_sid')

	},

	watch: {
		childdata(val) {
			if(val.goodspushinfo) this.editpushinfostart(val); //监听商品变化时获取商品详情数据
		},
	},
  
	methods:{
		renderHeader(h, { column, $index }) {
			return h('div', {
				style: {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
				}
			}, [
				// 主标题文本
				h('span', column.label),
				// 红色星号
				h('span', {
				style: {
					color: 'red',
					marginLeft: '4px'
				}
				}, '*')
			]);
		},

		//修改商品规格单位信息
		changepropertyunit(item,index) {
			this.currSKU = item
			this.propertyunitquery.index=index;
			this.propertyunitquery.productid=item.productid;
			this.propertyunitquery.lists=[];

			this.propertyunitquery.dialog=true;
			this.propertyunitquery.loading=true;
	        var resource = this.$resource(this.GLOBAL.domain+"Sell/index");
	        resource.query({act:'getunit',productid:item.productid,token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.propertyunitquery.loading=false;
		        }else{
		            this.propertyunitquery.lists = JSON.parse(Base64.decode(res.data.Data));
		            this.propertyunitquery.loading=false;
		        }
	        }).catch((res) => {
	            this.propertyunitquery.loading=false;
	        });
		},

		selectunitadd(item)  {
			const coupIndex = this.addquery.property.map(i => i.unitid).indexOf(item.id);
			if(coupIndex == -1) {
				this.addquery.property.push({
					cz_price: this.currSKU.cz_price,
					first: this.currSKU.first,
					img: this.currSKU.img,
					inventory: this.currSKU.inventory,
					isagent: this.currSKU.isagent,
					issplit: this.currSKU.issplit,
					lastinventory: this.currSKU.lastinventory,
					productid: this.currSKU.productid,
					property_name: this.currSKU.property_name,
					property_price: item.sell,
					market: item.market,
					sku: this.currSKU.sku,
					sort: this.currSKU.sort,
					spec: this.currSKU.spec,
					specialprice: this.currSKU.specialprice,
					unit: item.unit,
					unitid: item.id,
					useinventory: this.currSKU.useinventory,
					weight: this.currSKU.weight,
				});
				
			}else{
				this.$message.error(`该规格已存在,在第${coupIndex + 1}行`);
			}
			this.propertyunitquery.dialog=false;
		},
		//选择单位信息
		selectunitinfos(item) {
			let index=this.propertyunitquery.index;
			const coupIndex = this.addquery.property.map(i => i.unitid).indexOf(item.id);
			if(coupIndex == -1) {
			this.addquery.property[index].unitid=item.id;
			this.addquery.property[index].unit=item.unit;
			this.addquery.property[index].property_price=item.sell;
			}else{
				this.$message.error(`该规格已存在,在第${coupIndex + 1}行`);
			}
			if(index==0) {
				this.addquery.sellprice=item.sell;
				this.addquery.marketprice=item.market;
			}

			this.propertyunitquery.dialog=false;
		},



		//初始化数据发布
		//初始化步骤
		//1、检查当前商品是否有缓存
		//2、有缓存的提交至服务器进行保存或者甄别处理，并返回操作数据提示有草稿是否使用
		//3、使用草稿数据直接加载草稿数据
		//4、弃用草稿数据后非宠赞进销存用户无需理会，直接进行正常操作
		//5、进销存用户则重新获取商品数据进行加载
		getpushinfosstart() {
			this.opendrafstype=false; //关闭草稿缓存操作

			var soursecenter=this.childdata.noczgoodspushinfo ? false : true;  //判断是宠赞进销存用户，还是非宠赞进销存用户（false为否，true为是）
			if(soursecenter) this.query.agentid=this.childdata.agentid;
			if(soursecenter) this.query.id=this.childdata.data.id;

			//提取草稿信息
			var goodsid=this.childdata.data.goodsid > 0 ? this.childdata.data.goodsid : 0;
			this.addquery.goodsid=goodsid;
			var productid=this.childdata.data.id > 0 ? this.childdata.data.id : 0;
			var userid=this.$cookies.get('managerid');
			var cookiename='dmallgoods_'+goodsid+'_'+productid+'_'+userid;
			var olddata=localStorage.getItem(cookiename); 
			olddata ? olddata=JSON.parse(olddata) : olddata={};

			var name=olddata && olddata.name ? olddata.name : '草稿文件';
			var type=olddata && olddata.type ? olddata.type : 'add';
			var time=olddata && olddata.time ? olddata.time : '';
			var data=olddata && olddata.data ? olddata.data : '';

			//数据提交服务器校验
			this.addquery.loading=true;
			var resource = this.$resource(this.url);
			resource.save({act:'getgoodsdrafs',token:this.$cookies.get('token'),goodsid:goodsid,productid:productid,userid:userid,name:name,time:time,type:type,data:data}).then((res) => {
				if(res.data.Result>0){
					this.addquery.loading=false;

					//提取数据失败，直接取实时商品数据，第三方非宠赞进销存系统不做任何操作
					if(!soursecenter) return false;
					//使用宠赞进销存系统获取实时数据
					this.getgoodsinfos(this.childdata.data);

				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.addquery.loading=false;

					//第三方非宠赞进销存无草稿数据时，不处理
					if(!result.hasdrafs && !soursecenter) return false;
					//宠赞进销存无草稿数据时获取系统实时数据
					if(!result.hasdrafs && soursecenter) {
						this.getgoodsinfos(this.childdata.data);
						return false;
					}

					//有草稿数据时，提示是否沿用上一次编辑的草稿信息
					this.$confirm('该商品在草稿箱里已编辑部分内容，是否复用 ？', '提示', { type: 'warning',confirmButtonText: '继续上一次编辑',cancelButtonText:'重新加载' }).then(() => {
						//解析草稿信息，并将信息导入当前商品
						var drafdatas=JSON.parse(result.data);
						Object.assign(this.addquery,drafdatas)

					}).catch((res) => {
						//第三方非宠赞进销存不使用草稿数据时，不处理
						if(!soursecenter) return false;
						//宠赞进销存不使用草稿数据时获取系统实时数据
						if(soursecenter) {
							this.getgoodsinfos(this.childdata.data);
						}

					});
				}
			});
		},


		//编辑商品时处理
		editpushinfostart(val) {
			if(this.query.agentid==val.agentid && this.query.id==val.data.id) return false; //同一个商品信息正在编辑时不需做任何处理
			//信息变化时提示是否需要切换变更
			this.$confirm('您有商品正在进行编辑，是否放弃正在编辑的信息获取新的商品数据 ？', '提示', { type: 'warning' }).then(() => {
				if(this.addquery.act=='savemallgoodsnew' || this.addquery.act=='noczsavemallgoodsnew') this.pushinfoname='新增商品信息';
				if(this.addquery.act=='editmallgoodsnew' || this.addquery.act=='noczeditmallgoodsnew') this.pushinfoname='编辑商品信息';
				this.query.agentid=val.agentid;
				this.query.id=val.data.id;

				//检测当前商品在草稿箱是否有数据
				var goodsid=val.data.goodsid > 0 ? val.data.goodsid : 0;
				this.addquery.goodsid=goodsid;

				var productid=val.data.id > 0 ? val.data.id : 0;
				var userid=this.$cookies.get('managerid');
				var cookiename='dmallgoods_'+goodsid+'_'+productid+'_'+userid;
				var olddata=localStorage.getItem(cookiename); 
				olddata ? olddata=JSON.parse(olddata) : olddata={};

				var name=olddata && olddata.name ? olddata.name : '草稿文件';
				var type=olddata && olddata.type ? olddata.type : 'edit';
				var time=olddata && olddata.time ? olddata.time : '';
				var data=olddata && olddata.data ? olddata.data : '';

				//数据提交服务器校验
				this.addquery.loading=true;
				var resource = this.$resource(this.url);
				resource.save({act:'getgoodsdrafs',token:this.$cookies.get('token'),goodsid:goodsid,productid:productid,userid:userid,name:name,time:time,type:type,data:data}).then((res) => {
					if(res.data.Result>0){
						this.addquery.loading=false;
						//无草稿箱信息时直接获取实时数据
						this.getgoodsinfos(val.data); //获取订单信息详情

					}else{
						var result = JSON.parse(Base64.decode(res.data.Data));
						this.addquery.loading=false;

						//第三方非宠赞进销存无草稿数据时，不处理
						if(!result.hasdrafs) {
							this.getgoodsinfos(val.data); 
							return false;
						}

						//有草稿数据时，提示是否沿用上一次编辑的草稿信息
						this.$confirm('该商品上次已编辑部分内容，是否沿用 ？', '提示', { type: 'warning' }).then(() => {
							//解析草稿信息，并将信息导入当前商品
							var drafdatas=JSON.parse(result.data);
							Object.assign(this.addquery,drafdatas)

						}).catch((res) => {
							//第三方非宠赞进销存不使用草稿数据时，不处理
							this.getgoodsinfos(val.data); 
							return false;

						});
					}
				});

			}).catch(() => {
						
			});

		},


		///////////////////////////////////////////////////
		//草稿箱相关
		getdrafsnums() {
			var resource = this.$resource(this.url);
            resource.save({ act:'getdrafnums',token:this.$cookies.get('token')}).then((res) => {
                if(res.data.Result>0){
                    this.$message.error(res.data.Message);
                }else{
                    var data=JSON.parse(Base64.decode(res.data.Data));
					this.drafsnums=data.nums > 0 ? data.nums : 0;
                }
            }).catch((res) => {
                
            });
		},

		//查看草稿箱
		checkdraft() {
			this.opendrafs=true;
			this.drafquery.p=1;
			this.drafquery.rollpage=10;
			this.draflists=[];
			this.getcheckdraftlists();
		},

		//获取草稿箱信息
		getpagedraflists() {
			this.drafquery.p++;
			this.getcheckdraftlists();
		},

		//开启草稿缓存相关操作
		changedrafstyle() {
			var _this=this;
			setTimeout(function() {
				_this.opendrafstype=true; //开启草稿缓存操作
			},200);
		},

		//获取草稿箱数据列表
		getcheckdraftlists() {
			this.drafquery.loading=true;
			var resource = this.$resource(this.url);
            resource.save(this.drafquery).then((res) => {
                if(res.data.Result>0){
                    this.$message.error(res.data.Message);
					this.drafquery.loading=false;
                }else{
                    var result=JSON.parse(Base64.decode(res.data.Data));
					this.drafquery.addmore=result.lists.length > 0 ? true : false;

					this.drafsnums=result.count;
					var data=result.lists;

					var _this=this;
					data.forEach(function(item,index) {
						_this.draflists.push(item);
					});
					this.drafquery.loading=false;
                }
            }).catch((res) => {
                this.drafquery.loading=false;
            });
		},


		//删除草稿cookie
		deldrafs(item,index) {
			this.$confirm('您是否要删除当前草稿箱信息 ?', '警告', { type: 'warning'}).then(() => {

			    var resource = this.$resource(this.url);
				resource.save({act:'deldrafs',id:item.id,token:this.$cookies.get('token')}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
					}else{
						this.$delete(this.draflists,index);
					}
				}).catch((res) => {
					
				});

            }).catch(() => {
                 
            });
		},

		//草稿箱数据读取
		catchdrafs(item) {
			this.opendrafstype=false; //关闭草稿缓存操作
			this.$confirm('读取草稿件信息将会清空当前已录入的信息，是否继续 ?', '警告', { type: 'warning'}).then(() => {

				var resource = this.$resource(this.url);
				resource.save({act:'getdrafsinfos',id:item.id,token:this.$cookies.get('token')}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
					}else{
						this.opendrafs=false;
						var result=JSON.parse(Base64.decode(res.data.Data));
						Object.assign(this.addquery,result.data)
						// this.addquery=result.data; //刷新代理商品牌数据
						this.query.agentid=this.addquery.agentid;
						this.query.id=this.addquery.productid;

					}
				}).catch((res) => {
					
				});

                
            }).catch(() => {
                 
            });
		},

		//生成草稿件cookie
		createDrafsgoods() {
			var year=new Date().getFullYear().toString();
			var month=new Date().getMonth()+1;
			var date=new Date().getDate();
			var h=new Date().getHours();
			var m=new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
			var s=new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
			var time=year + '-' + month + '-' + date + ' ' + h + ':' + m + ':' + s;

			var userid=this.$cookies.get('managerid'); //管理员id
			var name=this.addquery.name!='' ? this.addquery.name : '草稿文件';
			var goodsid=this.addquery.goodsid > 0 ? this.addquery.goodsid : 0;
			var productid=this.addquery.productid > 0 ? this.addquery.productid : 0;
			var type=this.addquery.goodsid > 0 ? 'edit' : 'add';
			var data=JSON.stringify(this.addquery);

			//浏览器缓存的草稿商品
			var cookiename='dmallgoods_'+goodsid+'_'+productid+'_'+userid;

			//获取商品缓存信息列表
			var drafsgoodslists=localStorage.getItem('drafs_mall_goods_catalogue');
			drafsgoodslists=JSON.parse(drafsgoodslists);
			drafsgoodslists && drafsgoodslists.length > 0 ? '' : drafsgoodslists=[];

			var drafs={};
			drafs.goodsid=goodsid;
			drafs.productid=productid;
			drafs.name=name;
			drafs.userid=userid;
			drafs.type=type;
			drafs.time=time;
			drafs.data=data;

			localStorage.setItem(cookiename,JSON.stringify(drafs)); 

			//刷新目录数据
			var isadd=false;
			drafsgoodslists.forEach(function(item,index) {
				if(item.name==cookiename) isadd=true;
			});
			if(!isadd) drafsgoodslists.push({name:cookiename,isselect:1});
			localStorage.setItem('drafs_mall_goods_catalogue',JSON.stringify(drafsgoodslists));	
		},

		//草稿箱相关
		//////////////////////////////////////////////////


		/** 拖拽开启背景特效 **/
		startsortstyle() {
			this.changesortcolor={background:'rgb(245, 108, 108,.2)',border:'1px dashed red'};
		},

		/** 拖拽关闭背景特效 **/
		closesortstyle() {
			this.changesortcolor={background:'#fff',border:'1px dashed #fff'};
		},

		/** 鼠标按压商品 **/
		pressimg() {
			this.startsortstyle();
		},

		//商品拖拽排序
	    getdata(evt){
	    	console.log(evt.draggedContext.element.id);
	    },
	    datadragEnd(evt){
			this.closesortstyle(); 
			var num=0;
			this.addquery.banner.forEach(function(item,i) {
				num++;
				item.sort=num;
			});

			this.createDrafsgoods();  //生成草稿件商品cookies信息
	    },



		/** 保存已选中的分类属性信息 **/
		saveattribute() {
			var _this=this;
			this.addquery.attribute='';
			this.attributelists.forEach(function(item,index) {
				if(item.value!='') 
				_this.addquery.attribute=='' ?
				_this.addquery.attribute+=item.name+'|'+item.value :
				_this.addquery.attribute+='^'+item.name+'|'+item.value;
			});
			this.dshopattributeDialog=false;
		},

		/** 获取分类属性值信息 **/
		showattributeinfos() {
			var _this=this;
			this.attributelists=[];
			this.dshopattributeDialog=true;
			this.dshopattributeloading=true;
			var resource = this.$resource(this.GLOBAL.domain+"Dshop/index");
			resource.save({act:'getcatevalues',cateids:this.addquery.attributecatid,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.dshopattributeloading=false;
				}else{
					this.attributelists = JSON.parse(Base64.decode(res.data.Data));   
					this.dshopattributeloading=false;  

					//数据匹配
					var data=[];
					data=this.addquery.attribute.split('^');
					data.forEach(function(item,index) {
						item=item.split('|');
						_this.attributelists.forEach(function(t,i) {
							if(item[0]==t.name) t.value=item[1];
						});
					});


				}
			}).catch((res) => {
				this.dshopattributeloading=false;
			});

		},



		/** 保存选中的商品分类信息 **/
		savecatids() {
			var catids=''; var catnames=''; var _this=this;
			if(this.doudiancatelists1.length > 0) {
				if(this.doudiancate1=='') {this.$message.error("请选择商品一级分类");return false;}
				catids=this.doudiancate1;
				this.doudiancatelists1.forEach(function(item,i) {
					if(_this.doudiancate1==item.id) catnames=item.name;
				});
			} 

			if(this.doudiancatelists2.length > 0) {
				if(this.doudiancate2=='') {this.$message.error("请选择商品二级分类");return false;}
				catids+=","+this.doudiancate2;
				this.doudiancatelists2.forEach(function(item,i) {
					if(_this.doudiancate2==item.id) catnames+=" / "+item.name;
				});
			} 

			if(this.doudiancatelists3.length > 0) {
				if(this.doudiancate3=='') {this.$message.error("请选择商品三级分类");return false;}
				catids+=","+this.doudiancate3;
				this.doudiancatelists3.forEach(function(item,i) {
					if(_this.doudiancate3==item.id) catnames+=" / "+item.name;
				});
			} 

			if(this.doudiancatelists4.length > 0) {
				if(this.doudiancate4=='') {this.$message.error("请选择商品四级分类");return false;}
				catids+=","+this.doudiancate4;
				this.doudiancatelists4.forEach(function(item,i) {
					if(_this.doudiancate4==item.id) catnames+=" / "+item.name;
				}); 
			}

			if(this.doudiancatelists5.length > 0) {
				if(this.doudiancate5=='') {this.$message.error("请选择商品五级分类");return false;}
				catids+=","+this.doudiancate5;
				this.doudiancatelists5.forEach(function(item,i) {
					if(_this.doudiancate5==item.id) catnames+=" / "+item.name;
				});
			}


			//切换分类清空一设置分类属性信息询问操作
			if(catids!=this.addquery.attributecatid) { 
				this.$confirm('切换抖店商品分类操作会将已选中的商品分类属性信息清空，是否继续 ?', '提示', { type: 'warning' }).then(() => {
					this.addquery.doudiancatid=catids;
					this.addquery.doudiancatname=catnames;
					this.addquery.attributecatid=catids;
					this.addquery.attribute='';
					this.doudiancateDialog=false;

              	}).catch((res) => {
                      
               	});

			}else {
				this.addquery.doudiancatid=catids;
				this.addquery.doudiancatname=catnames;
				this.addquery.attributecatid=catids;
				this.doudiancateDialog=false;
			}

		},


		/** 获取抖店商品分类信息 **/
		getdshopgoodscate() {
			this.doudiancateDialog=true;
			this.doudiancate1='';
			this.doudiancate2='';
			this.doudiancate3='';
			this.doudiancate4='';
			this.doudiancate5='';
			this.doudiancate6='';
			this.doudiancatelists1=[];
			this.doudiancatelists2=[];
			this.doudiancatelists3=[];
			this.doudiancatelists4=[];
			this.doudiancatelists5=[];
			this.doudiancatelists6=[];

			//获取抖店商品分类信息
			this.getdshopgoodscatedata(0);
		},

		/** 获取抖音商品分类数据 **/
		getdshopgoodscatedata(number,pid=0) {
			var parentid=this.changdshopcates(number);
			this.doudiancateloading=true;
			var resource = this.$resource(this.GLOBAL.domain+"Dshop/index");
			resource.save({act:'getdoudiancates',type:number,parentid:parentid,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.doudiancateloading=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));     
					this.doudiancateloading=false;

					if(number==0) this.doudiancatelists1=result;
					if(number==1) this.doudiancatelists2=result;
					if(number==2) this.doudiancatelists3=result;
					if(number==3) this.doudiancatelists4=result;
					if(number==4) this.doudiancatelists5=result;
					if(number==5) this.doudiancatelists6=result;

				}
			}).catch((res) => {
				this.doudiancateloading=false;
			});

		},

		//调整分类数据
		changdshopcates(number) {
			if(number==0) { //编辑一级分类
				this.doudiancate1='';
				this.doudiancate2='';
				this.doudiancate3='';
				this.doudiancate4='';
				this.doudiancate5='';
				this.doudiancate6='';
				this.doudiancatelists1=[];
				this.doudiancatelists2=[];
				this.doudiancatelists3=[];
				this.doudiancatelists4=[];
				this.doudiancatelists5=[];
				this.doudiancatelists6=[];
				return 0;

			}else if(number==1) { //编辑二级分类
				this.doudiancate2='';
				this.doudiancate3='';
				this.doudiancate4='';
				this.doudiancate5='';
				this.doudiancate6='';
				this.doudiancatelists2=[];
				this.doudiancatelists3=[];
				this.doudiancatelists4=[];
				this.doudiancatelists5=[];
				this.doudiancatelists6=[];
				return this.doudiancate1;
 
			}else if(number==2) { //编辑三级分类
				this.doudiancate3='';
				this.doudiancate4='';
				this.doudiancate5='';
				this.doudiancate6='';
				this.doudiancatelists3=[];
				this.doudiancatelists4=[];
				this.doudiancatelists5=[];
				this.doudiancatelists6=[];
				return this.doudiancate2;

			}else if(number==3) { //编辑四级分类
				this.doudiancate4='';
				this.doudiancate5='';
				this.doudiancate6='';
				this.doudiancatelists4=[];
				this.doudiancatelists5=[];
				this.doudiancatelists6=[];
				return this.doudiancate3;

			}else if(number==4) { //编辑五级分类
				this.doudiancate5='';
				this.doudiancate6='';
				this.doudiancatelists5=[];
				this.doudiancatelists6=[];
				return this.doudiancate4;

			}else if(number==5) { //编辑五级分类
				this.doudiancate6='';
				this.doudiancatelists6=[];
				return this.doudiancate5;
			}
		},


		/** 修改当前规格价格 **/
		changepropertyprice(item) {
			if(this.addquery.ispushdoudian=='是') {
				this.$confirm('是否同步修改发布到抖店上的价格 ?', '提示', { type: 'warning' }).then(() => {
					var _this=this;
					this.addquery.doudianinfos.forEach(function(t,i) {
						if((item.dshopcode && t.dshopcode && item.dshopcode==t.dshopcode) || 
						   (item.productid==t.productid && item.unitid==t.unitid))
						   t.price=item.property_price;
					});

				}).catch(() => {
					
				});
			}
		},


		/** 删除发布到抖音店铺的规格 **/
		deldoudianspec(number) {
			this.$delete(this.addquery.doudianinfos,number);
		},


		/** 保存已选中的规格信息 **/
		savedshopspec() {
			//提取已选中的规格信息
			var _this=this;
			var specs=[];
			var isexit=false;

			var adddshopspec=this.addquery.doudianinfos;
			this.mydshoplists.forEach(function(item,i) {
				item.isselect==1 ? specs.push(item) : '';
			});

			if(specs.length==0) {this.$message.error('请选择要发布到抖店的规格');return false;}
			specs.forEach(function(t,i) {
				isexit=false;
				adddshopspec.forEach(function(tt,ii) {
					if(t.dshopid==tt.dshopid && (t.dshopcode==tt.dshopcode || (t.productid==tt.productid && t.unitid==tt.unitid))) 
					isexit=true;
				});
				isexit ? '' : adddshopspec.push(t);
			});

			adddshopspec.sort(this.comparesort('price'));
			adddshopspec.sort(this.comparesort('dshopid'));
			this.mydshopDialog=false;
		},	


		/** 获取可发布的抖店信息 **/
		addgoods_to_douyin_shop() {
			if(this.addquery.property.length==0) {this.$message.error("请先至少添加一个规格信息");return false;}

			this.mydshopDialog=true;
			this.getmydshopdata();
		},

		/** 获取我的抖店数据 **/
		getmydshopdata() {
			this.mydshoploading=true;
			var resource = this.$resource(this.GLOBAL.domain+"Dshop/index");
			resource.save({act:'getmyshoplists',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.mydshoploading=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));   
					this.mydshoploading=false;

					var data=[];
					var _this=this;
					//获取商品规格信息
					var speclists=this.addquery.property;
					//获取已选中的商品规格信息
					var selectspecs=this.addquery.doudianinfos;
					var number=-1;
					var temp={};
					
					//重新组装参数
					this.mydshoplists=[];
					result.forEach(function(t,i) {
						//匹配规格信息
						speclists.forEach(function(tt,ii) {
							temp={};
							tt.dshopcode && tt.dshopcode!='' ? '' : tt.dshopcode=("000000000" + 10000000000 * Math.random()).match(/(\d{10})(\.|$)/)[1];
							temp.productid=tt.productid;
							temp.sku=tt.sku;
							temp.unitid=tt.unitid;
							temp.unit=tt.unit;
							temp.dshopid=t.dshopid;
							temp.dshopname=t.dshopname;
							temp.price=tt.property_price;
							temp.property_name=tt.property_name;
							temp.dshopcode=tt.dshopcode;
							temp.isverify='';
							temp.isselect=0;
							temp.update_status=0;
							temp.update_error_reason='';

							//检测是否已选中该规格
							number=-1;
							if(selectspecs.length > 0) {
								selectspecs.forEach(function(ttt,iii) {
									if((t.dshopid==ttt.dshopid && tt.productid > 0 && tt.productid==ttt.productid && tt.unitid==ttt.unitid) || 
								   	   (t.dshopid==ttt.dshopid && tt.dshopcode==ttt.dshopcode)) number=iii;
								});
							}

							if(number >=0) selectspecs[number].dshopcode=tt.dshopcode;
							_this.mydshoplists.push(temp);

						});
					});

					//数据排序调整
					this.mydshoplists.sort(this.comparesort('price'));
					this.mydshoplists.sort(this.comparesort('dshopid'));
					this.mydshoplists=JSON.parse(JSON.stringify(this.mydshoplists));
				}
			}).catch((res) => {
				this.mydshoploading=false;
			});
		},

		//排序调整
		comparesort(property) {
			return function(a,b){
				var value1 = a[property];
				var value2 = b[property];
				return value1 - value2;
			}
		},


		/** 获取当前代理商是否具有接入抖音店铺的数据权限 **/
		checkdoudianauth() {
			var resource = this.$resource(this.url);
			resource.save({act:'getisdoudian',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));     
					this.isdoudian=result.isdoudian;              
				}
			}).catch((res) => {
				
			});
		},


		/** 获取抖店客服电话 **/
		getserverphones() {
			var resource = this.$resource(this.GLOBAL.domain+"Dshop/index");
			resource.save({act:'getserverphone',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));     
					this.addquery.doudianmobile=result.phone;     
				}
			}).catch((res) => {
				
			});
		},


		/** 获取运费模板信息 **/
		getshippingtemplists() {
			this.shippingtemploading=true;
			var resource = this.$resource(this.GLOBAL.domain+"Shippingarea/index");
			resource.save({act:'getshippingtemplistsnew',token:this.$cookies.get('token'),temptypelists:1,sort:1,p:1,rollpage:10000000}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.shippingtemploading=false;
				}else{
					this.shippingtemplists = JSON.parse(Base64.decode(res.data.Data));   
					this.shippingtemploading=false;     

					//第三方非宠赞进销存数据中心上货默认匹配模板
					if(this.childdata.noczgoodspushinfo && this.addquery.shipping_tempidid=='' && this.shippingtemplists.length > 0)
					this.addquery.shipping_tempidid=this.shippingtemplists[0]['id'];	

				}
			}).catch((res) => {
				this.shippingtemploading=false;
			});
		},


		/** 获取当前代理商品牌信息 **/
		getsysbrands() {
			this.sysbrandloading=true;
			var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
			resource.query({act:'lists',token:this.$cookies.get('token'),jdshow:0,rollpage:100000}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.sysbrandlists = JSON.parse(Base64.decode(res.data.Data));
					this.sysbrandloading=false;
				}
			}).catch((res) => {
				this.$message.error(this.GLOBAL.errortext);
				this.sysbrandloading=false;
			});
		},


		/** 查看是否开启分销权限 **/
		getSplitshow() {
			var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
				resource.query({act:'getsplit',token:this.$cookies.get('token')}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
					}else{
						var result = JSON.parse(Base64.decode(res.data.Data));
						this.issplit=result.issplit;
					}
				}).catch((res) => {
					this.$message.error(this.GLOBAL.errortext);
				});
		},

		/** 修改库存信息 **/
		changeinventorys(item) {
			item.lastinventory=Number(item.inventory-item.useinventory);
			this.createDrafsgoods();  //生成草稿件商品cookies信息
		},

		/** 修改商品spu（主要用于自动填充spu商品信息作为第一个规格原则） **/
		changegoodsspu() {
			if(this.query.datacenter!='cz') { //数据中心不在宠赞时的特殊处理
				var _this=this;
				var hasproperty=false;
				this.addquery.property.forEach(function(item,i) {
					if(item.first==1) { //找到相同的sku时进行标记
						hasproperty=true; //标记存在
						item.sku=_this.addquery.spu;
						item.barcode=_this.addquery.barcode;
						item.property_name=='' ? item.property_name=_this.addquery.name : ''; //规格名称无数据时进行填充
						item.spec=='' ? item.spec=_this.addquery.spec : ''; //规格名称无数据时进行填充
						item.property_price=='' ? item.property_price=_this.addquery.sellprice : ''; //无销售金额时填充
						return false;
					}
				});
				if(hasproperty) return false;  //当前该sku已存在，无需重新添加
				
				//当前sku不存在，重新添加并且强制作为第一个规格
				var propertys=[];
				propertys.push({productid:this.addquery.productid,property_name:this.addquery.name,property_price:this.addquery.sellprice,
										specialprice:0,unitid:this.addquery.unitid,unit:this.addquery.unit,img:'',weight:'',
										isagent:0,cz_price:0,spec:this.addquery.spec,issplit:false,sku:this.addquery.spu,barcode:this.addquery.barcode,
										inventory:0,useinventory:0,lastinventory:0,first:1});
				this.addquery.property.forEach(function(item,ii) {propertys.push(item);});
				this.addquery.property=propertys; //替换新的规格信息
			}
		},


		/** 获取宠赞系统的单位信息 **/
		getnoczunilists() {
			var resource = this.$resource(this.url);
	        resource.save({act:'getmallunitlists',token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
					this.noczunilists = JSON.parse(Base64.decode(res.data.Data));
		        }
	        }).catch((res) => {
	            
	        });
		},

		/** 获取代理商所使用的数据中心 **/
		getagentcenter() {
			var resource = this.$resource(this.url);
	        resource.save({act:'getdatacenter',token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.query.datacenter=result.datacenter;
		        }
	        }).catch((res) => {
	            
	        });
		},

		// 校验商品数据是否填写完整
		checkgoodsdata() { 
			let isok = true;
			this.addquery.property.some((item, index) => {
				if (!item.sku) {
					this.$message.error(`第${index + 1}行数据的sku不能为空`);
					isok = false;
					return true;
				}
				if (!item.property_name) {
					this.$message.error(`第${index + 1}行数据的规格名称不能为空`);
					isok = false;
					return true;
				}
				if (!item.property_price) {
					this.$message.error(`第${index + 1}行数据的价格不能为空`);
					isok = false;
					return true;
				}
				if (!item.market) {
					this.$message.error(`第${index + 1}行数据的零售价不能为空`);
					isok = false;
					return true;
				}
				if (!item.weight) {
					this.$message.error(`第${index + 1}行数据的重量不能为空`);
					isok = false;
					return true;
				}
			});
			return isok;
		},
		/** 新增商品信息 **/
		createSave() {
			if (!this.checkgoodsdata()) return
			this.$refs.form.validate(valid => {
				if (valid) {
					// 执行提交操作
					console.log('验证通过');
					this.$confirm('您是否确认要保存或修改该商品信息 ?', '提示', { type: 'warning' }).then(() => {
						this.addquery.loading=true;
						this.addquery.token=this.$cookies.get('token');
						this.addquery.property.forEach(item => {
							if (item.especially_price == '' || !item.especially_price) {
								item.especially_price = 0;
							}
						})
						var resource = this.$resource(this.url);
						resource.save(this.addquery).then((res) => {
							if(res.data.Result>0){
								if(res.data.Result=='70001') this.$router.push('/login')
								this.$message.error(res.data.Message);
								this.addquery.loading=false;
							}else{
								//处理草稿数据
								var userid=this.$cookies.get('managerid'); //管理员id
								var goodsid=this.addquery.goodsid > 0 ? this.addquery.goodsid : 0;
								var productid=this.addquery.productid > 0 ? this.addquery.productid : 0;
								var syscookiename='dmallgoods_'+goodsid+'_'+productid+'_'+userid;
		
								//清空缓存箱
								localStorage.setItem(syscookiename,null);
								//修改草稿箱缓存列表
								var mallgoodsdrafs=localStorage.getItem('drafs_mall_goods_catalogue');
								mallgoodsdrafs=JSON.parse(mallgoodsdrafs);
								mallgoodsdrafs.length > 0 ? '' : mallgoodsdrafs=[];
								var idx=-1;
								mallgoodsdrafs.forEach(function(tt,ii) {
									syscookiename==tt.name ? idx=ii : '';
								});
								  idx >=0 ? this.$delete(mallgoodsdrafs,idx) : '';
								  localStorage.setItem('drafs_mall_goods_catalogue',JSON.stringify(mallgoodsdrafs));
		
		
								this.addquery.loading=false;
								this.addquery.productid='';
								this.addquery.agentid='';
								this.addquery.name='';
								this.addquery.spec='';
								this.addquery.pettype='';
								this.addquery.catid=[];
								this.addquery.isforeight='';
								this.addquery.sellprice='';
								this.addquery.marketprice='';
								this.addquery.thumb='';
								this.addquery.packing='';
								this.addquery.content='';
								this.addquery.spu='';
								this.addquery.banner=[];
								this.addquery.property=[];
								this.addquery.bannnersort='';
								this.addquery.shipping_tempidid='';
		
								this.localselectgoods.id='';
								this.localselectgoods.name='';
								this.localselectgoods.unitid='';
								this.localselectgoods.spec='';
								this.localselectgoods.sku='';
								this.localselectgoods.img='';
								this.localselectgoods.unitlists=[];
								//操作成功分情况进行处理
								if(this.addquery.act=='savemallgoodsnew') { //非第三方添加商品信息时
									this.$emit('closechild','Goodspushinfo'); //关闭窗口
									this.$emit('listenchild',{name:'发布商品',url:'Goodspush',data:{isgoodspush:true}});
									this.$emit('listenchild',{name:'在售商品',url:'Goods',data:{isgoodslists:true}});
		
								}else if(this.addquery.act=='editmallgoodsnew') { //非第三方编辑商品信息时
									this.$emit('closechild','Goodspushinfo'); //关闭窗口
									this.$emit('listenchild',{name:'发布商品',url:'Goodspush',data:{isgoodspush:true}});
									this.$emit('listenchild',{name:'在售商品',url:'Goods',data:{isgoodslists:true}});
		
								}else if(this.addquery.act=='noczsavemallgoodsnew') { //第三方添加商品信息时
									this.$emit('listenchild',{name:'在售商品',url:'Goods',data:{isgoodslists:true}});
		
								}else if(this.addquery.act=='noczeditmallgoodsnew') { //第三方编辑商品信息时
									this.$emit('closechild','Goodspushinfo'); //关闭窗口
									this.$emit('listenchild',{name:'在售商品',url:'Goods',data:{isgoodslists:true}});
		
								}
								this.$message.success("添加或修改商品信息成功");
		
							}
						}).catch((res) => {
							this.addquery.loading=false;
						});
		
					}).catch(() => {
						
					});
					
				} else {
					console.log('验证失败');
					return false;
				}
			});

		},


		/** 新增封面图 **/
		addcoverthumb() {
			this.uploadsquery.type='cover';
			document.getElementById('coverthumb').click();
		},

		/** 新增banner主图 **/
		addbannerthumb() {
			this.uploadsquery.type='banner';
			document.getElementById('bannerthumb').click();
		},

		/** 新增规格图片 **/
		addpropertythumb(index) {
			this.uploadsquery.type='property';
			this.uploadsquery.index=index;
			document.getElementById('coverthumb').click();
		},


		/** 获取图片信息回传 **/
		uploadfiles(el) {
			var images=el.target.files;
			var resource = this.$resource(this.GLOBAL.uploadUrl);
	    	for (let i = 0; i < el.target.files.length; i++) {
	    		var formData = new FormData();
	    		formData.append('file', el.target.files[i]);
				formData.append('sys_type', 'cz');
				formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    		resource.save(formData).then((res) => {
		            var data=JSON.parse(Base64.decode(res.body.Data));
		            if(data.Result > 0) {
		            	this.$message.error(data.msg);
		            }else {
						if(this.uploadsquery.type=='cover') { //封面图
							this.addquery.thumb=this.GLOBAL.staticUrl+data.imgsrc;
							//var size=this.getimgwidthandheight(this.addquery.thumb);

						}else if(this.uploadsquery.type=='property') { //规格图
							this.addquery.property[this.uploadsquery.index].img=this.GLOBAL.staticUrl+data.imgsrc;
						}

						this.createDrafsgoods();  //生成草稿件商品cookies信息
						
		            }
		        }).catch((res) => {
		        	
		        });
	    	}
			el.target.value = '';
		},


		/** 获取批量主图回传信息 **/
		uploadallfiles(el) {
			var resource = this.$resource(this.GLOBAL.uploadUrl);
			var nums=el.target.files.length;

	    	for (let i = 0; i < el.target.files.length; i++) {
	    		var formData = new FormData();
	    		formData.append('file', el.target.files[i]);
				formData.append('sys_type', 'cz');
				formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    		resource.save(formData).then((res) => {
		            var data=JSON.parse(Base64.decode(res.body.Data));
		            if(data.Result > 0) {
		            	this.$message.error(data.msg);
						nums--;
						if(nums==0) this.createDrafsgoods();  //生成草稿件商品cookies信息   

		            }else {
						this.addquery.bannnersort++;
						var sort=this.addquery.bannnersort;
						this.addquery.banner.push({url:this.GLOBAL.staticUrl+data.imgsrc,sort:sort});		
						nums--;
						if(nums==0) {
							this.createDrafsgoods();  //生成草稿件商品cookies信息 
						}           	
		            }
		        }).catch((res) => {
		        	nums--;
					if(nums==0) this.createDrafsgoods();  //生成草稿件商品cookies信息   
		        });
	    	}
			el.target.value = '';
		},


		/** 获取批量详情图回传信息 **/
		uploadallfiles1(el) {
			let quill = this.$refs.mycreateQuillEditor.quill;	
			var resource = this.$resource(this.GLOBAL.uploadUrl);
			var _this=this;
			var nums=el.target.files.length;

	    	for (let i = 0; i < el.target.files.length; i++) {
	    		var formData = new FormData();
	    		formData.append('file', el.target.files[i]);
				formData.append('sys_type', 'cz');
				formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    		resource.save(formData).then((res) => {
		            var data=JSON.parse(Base64.decode(res.body.Data));
		            if(data.Result > 0) {
		            	this.$message.error(data.msg);
						nums--;
						if(nums==0) this.createDrafsgoods();  //生成草稿件商品cookies信息    
		            }else {
						var img=this.GLOBAL.staticUrl+data.imgsrc;
						// 获取光标所在位置
						this.qilllength=quill.getSelection().index;
				        // 插入图片  res.info为服务器返回的图片地址
				        quill.insertEmbed(this.qilllength, 'image', img);
				        // 调整光标到最后
				        quill.setSelection(this.qilllength + 1);

						nums--;
						if(nums==0) this.createDrafsgoods();  //生成草稿件商品cookies信息    

		            }
		        }).catch((res) => {
		        	
					nums--;
					if(nums==0) this.createDrafsgoods();  //生成草稿件商品cookies信息    

		        });
	    	}
			el.target.value = '';
		},


		/** 删除商品图片 **/
		delbanner(index) {
			this.$delete(this.addquery.banner,index);
			this.changebannersort(); //商品主图重新排序

			this.createDrafsgoods();  //生成草稿件商品cookies信息
		},

		/** 商品主图顺序重新排列 **/
		changebannersort() {
			var banner=this.addquery.banner;
			this.addquery.banner=[];
			this.addquery.banner=this.changesortfunction(banner);
		},

		//自定义算法排序（冒泡排序）
		changesortfunction(arr) {
			var newdata=[];
			for(var i=0;i<arr.length;i++){
				for(var j=i;j<arr.length;j++){
					if(Number(arr[i].sort) > Number(arr[j].sort)){
						var tmp=arr[i];
						arr[i]=arr[j];
						arr[j]=tmp;
					}
				}
			}
			return arr;
		},
 		


		/** 左下脚展示图片放大 **/
		showimgs(url) {
			this.showimgurl=url;
			this.showimgclass=this.openclass;
		},

		/** 关闭展示的图片 **/
		closimg() {
			this.showimgclass=this.closeclass;
		},

		/** 删除规格信息 **/
		delproperty(item,index) {
			if(this.addquery.act=='noczsavemallgoodsnew' || this.addquery.act=='noczeditmallgoodsnew') {
				this.$confirm('删除该规格会同步清空其库存，并不可恢复，是否继续？', '提示', { type: 'warning' }).then(() => {
					this.$delete(this.addquery.property,index);
					this.createDrafsgoods(); //更新草稿箱信息

				}).catch(() => {
						
				});
			}else {
				this.$delete(this.addquery.property,index);
				this.createDrafsgoods(); //更新草稿箱信息
			}

			//同步删除下面已选中的抖店规格
			var _this=this;
			var number=-1;
			this.addquery.doudianinfos.forEach(function(tt,ii) {
				number=-1;
				if(item.dshopcode==tt.dshopcode || (item.productid==tt.productid && item.unitid==tt.unitid)) number=ii;
				number >= 0 ? _this.$delete(_this.addquery.doudianinfos,number) : '';
			});

		},

		
		/** 点击添加规格（选取单位） **/
		addpropertyunionunit() {
			var isadd=false; var _this=this; var units={};
			this.addquery.property.forEach(function(t,i) {if(_this.localselectgoods.id==t.productid) isadd=true});
			// this.addquery.property.forEach(function(t,i) {if(_this.localselectgoods.unitid==t.unitid) isadd=true});
			if(isadd) return false;

			//取出选中的单位信息
			this.localselectgoods.unitlists.forEach(function(item,i) {
				if(_this.localselectgoods.unitid==item.id) units=item;
			});

			this.addquery.property.push({productid:this.localselectgoods.id,
										property_name:this.localselectgoods.name,
										property_price:units.sell,
										specialprice:0,
										unitid:units.id,
										unit:units.unit,
										img:this.localselectgoods.img,
										weight:'',
										isagent:0,
										cz_price:0,
										spec:this.localselectgoods.spec,
										issplit:false,
										sku:this.localselectgoods.sku,
										barcode:this.localselectgoods.barcode,
										inventory:units.inventory,
										useinventory:units.useinventory,
										lastinventory:units.lastinventory});
			this.createDrafsgoods();
		},


		/** 选择商品信息 **/
		selectgoods(item) {
			if(this.addquery.agentid==100000) { //京东商品
				//是否商品已经被添加，避免重复添加
				var isadd=false;
				this.addquery.property.forEach(function(t,i) {if(item.id==t.productid) isadd=true});
				if(isadd) {this.propertygoodsDialog=false;return false;}
				this.addquery.property.push({productid:item.id,property_name:item.name,property_price:item.price,
											 specialprice:0,unitid:0,unit:'',img:item.thumb,weight:item.weight,
											 isagent:0,cz_price:item.cz_price,spec:item.spec,issplit:false,sku:item.sku,barcode:item.barcode,
											 inventory:0,useinventory:0,lastinventory:0});

			}else { //其它代理商
				this.localselectgoods.id=item.id;
				this.localselectgoods.name=item.name;
				this.localselectgoods.img=item.thumb;
				this.localselectgoods.spec=item.spec;
				this.localselectgoods.sku=item.number;
				this.localselectgoods.barcode=item.barcode,
				this.localselectgoods.unitid=item.unitid;
				this.localselectgoods.unitlists=item.unitlists;

			}
			this.propertygoodsDialog=false;
		},


		/** 非宠赞用户添加商品规格信息入口 **/
		addpropertyinfos() {
			this.addquery.property.push({productid:'',property_name:'',property_price:'',
											 specialprice:0,unitid:0,unit:'',img:'',weight:'',
											 isagent:0,cz_price:'',spec:'',issplit:false,sku:'',
											 barcode:'',inventory:0,useinventory:0,lastinventory:0});

			this.createDrafsgoods(); //生成草稿件商品cookies信息
		},

		
		/** 获取选取规格的商品信息 **/
		getpropertygoods() {
			this.propertygoodsquery.agentid=this.addquery.agentid;
			this.propertygoodsquery.id=this.addquery.goodsid;
			this.propertygoodsquery.key='';
			this.propertygoodsquery.brandid='';
			this.propertygoodsquery.p=1;
			this.propertygoodsquery.rollpage=10;
			this.getbrandinfos(this.addquery.agentid); //刷新代理商品牌数据
			this.propertygoodsDialog=true;
			this.getpropertygoodsnewdata();
		},


		/** 获取规格商品信息数据 **/
		getpropertygoodsnewdata() {
			if(this.propertygoodsquery.ischange) {
				this.propertygoodsquery.p=1;
				this.propertygoodsquery.rollpage=10;
			}

			this.propertygoodsquery.loading=true;
			var resource = this.$resource(this.url);
	        resource.save(this.propertygoodsquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.propertygoodsquery.loading=false;
		        }else{
		            this.propertygoodslist = JSON.parse(Base64.decode(res.data.Data));
					this.propertygoodsrows = parseInt(res.data.count);
					if(this.propertygoodsquery.ischange) this.propertygoodsquery.ischange=false;
					this.propertygoodsquery.loading=false;
		        }
	        }).catch((res) => {
	            this.propertygoodsquery.loading=false;
	        });
		},

		pagePropertySizeChange(val) {
	        this.propertygoodsquery.rollpage = val;
	        this.getpropertygoodsnewdata();
	    },
	    pagePropertyCurrentChange(val) {
	        this.propertygoodsquery.p = val;
	        this.getpropertygoodsnewdata();
	    },


		//获取线上商城分类列表
	    getmallCategoryList(){
	        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
	        resource.query({ act:'getmallcatelist',token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.mallcategorylist = JSON.parse(Base64.decode(res.data.Data));
		        }
	        }).catch((res) => {
	            
	        });
	    },
		
		/** 获取待发布的商品信息 **/
		getgoodsinfos(item) {
			this.addquery.productid=item.id;
			this.addquery.agentid=this.query.agentid;
			this.addquery.name='';
			this.addquery.spec='';
			this.addquery.pettype='';
			this.addquery.catid=[];
			this.addquery.isforeight='';
			this.addquery.sellprice='';
			this.addquery.marketprice='';
			this.addquery.thumb='';
			this.addquery.packing='';
			this.addquery.content='';
			this.addquery.spu='';
			this.addquery.barcode='';
			this.addquery.brandid='';
			this.addquery.banner=[];
			this.addquery.property=[];
			this.addquery.bannnersort='';
			this.addquery.shipping_tempidid='';

			this.localselectgoods.id='';
			this.localselectgoods.name='';
			this.localselectgoods.unitid='';
			this.localselectgoods.spec='';
			this.localselectgoods.sku='';
			this.localselectgoods.img='';
			this.localselectgoods.unitlists=[];

			this.addquery.loading=true;
			var resource = this.$resource(this.url);
	        resource.save({act:'getgoodsinfosnews',id:this.addquery.goodsid,productid:item.id,agentid:this.query.agentid,token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.addquery.loading=false;

		        }else{
		            var result = JSON.parse(Base64.decode(res.data.Data));
					console.log('商品详情》》》》》》',result);

					//商城商品数据
					this.addquery.name=result.name;
					this.addquery.spec=result.spec;
					this.addquery.pettype=result.type;
					this.addquery.catid=result.catid;
					this.addquery.isforeight=result.isforeight=='' ? '' : Number(result.isforeight);
					this.addquery.sellprice=result.sellprice;
					this.addquery.marketprice=result.marketprice;;
					this.addquery.thumb=result.thumb;
					this.addquery.packing=result.packing;
					this.addquery.content=result.content;
					this.addquery.spu=result.spu;
					this.addquery.barcode=result.barcode;
					this.addquery.brandid=result.brandid;
					this.addquery.banner=result.banner;
					this.addquery.property=result.property;
					this.addquery.bannnersort=result.bannnersort;
					this.addquery.shipping_tempidid=result.shipping_tempidid;
					this.addquery.property.forEach(function(item,i) {
						item.issplit==1 ? item.issplit=true : item.issplit = false;
						item.expire_at = +item.expire_at;
						if (!item.expire_at) {
							item.expire_at = '';
						} else {
							item.expire_at = new Date(item.expire_at*1000);
						}
					});

					//抖店商品数据
					this.addquery.ispushdoudian=result.ispushdoudian;
					this.addquery.doudianname=result.doudianname;
					this.addquery.doudiancatid=result.doudiancatid;
					this.addquery.doudiancatname=result.doudiancatname;
					this.addquery.attribute=result.attribute;
					this.addquery.attributecatid=result.attributecatid;
					this.addquery.doudianmobile=result.doudianmobile;
					this.addquery.delivery_delay_day=Number(result.delivery_delay_day);
					this.addquery.supply_7day_return=Number(result.supply_7day_return);
					this.addquery.doudianpaytype=Number(result.doudianpaytype);
					this.addquery.doudianinfos=result.doudianinfos;
					this.addquery.doudianinfos_model=result.doudianinfos_model;
					this.addquery.loading=false;

					/** 如商品没有添加运费模板则自动为其匹配模板模板 **/
					if(result.shipping_tempidid=='' && this.shippingtemplists.length > 0) {
						this.addquery.shipping_tempidid=this.shippingtemplists[0]['id'];
					}

		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
				this.addquery.loading=false;
	        });
		},


		/** 获取代理商品牌信息 **/
		getbrandinfos(agentid) {
			var resource = this.$resource(this.url);
	        resource.save({act:'getagentbrands',agentid:agentid,token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
		},


		//重置表单
		reset() {
			this.$refs.create.resetFields();
		},
		    
		//获取功能权限
		getactionauth() {
			var data =this.$cookies.get('actionauth');
		    data=JSON.parse(data);
		    this.actionauth=data;
		},

		/** 监听文本变化 **/
		onEditorchange() {
			this.createDrafsgoods();  //生成草稿件商品cookies信息
		},


		//宠赞商品刷新条形码
		freshbarcode() {
			var productids=[];
			this.addquery.property.forEach(function(item,i) {item.productid > 0 ? productids.push(item.productid) : ''; });

			this.barcodeloading=true;
			var resource = this.$resource(this.url);
	        resource.save({act:'freshbarcode',productids:productids.join(','),token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.barcodeloading=false;
		        }else{
					this.barcodeloading=false;
		            var result = JSON.parse(Base64.decode(res.data.Data));
					//整形
					var codelists={};
					result.forEach(function(item,i) {codelists[item.id]=item.barcode; });
					
					//刷新商品条形码
					this.addquery.barcode=codelists[this.addquery.productid] ? codelists[this.addquery.productid] : '';
					//刷新规格条形码
					this.addquery.property.forEach(function(item,i) {
						codelists[item.productid] ? item.barcode=codelists[item.productid] : item.barcode='';
					});

		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });

		},


		//同步条形码到第一个规格
		changegoodsbarcode() {
			if(this.query.datacenter!='cz') { //数据中心不在宠赞时的特殊处理
				var _this=this;
				var hasproperty=false;
				this.addquery.property.forEach(function(item,i) {
					if(item.first==1) { //找到相同的sku时进行标记
						hasproperty=true; //标记存在
						item.sku=_this.addquery.spu;
						item.barcode=_this.addquery.barcode;
						item.property_name=='' ? item.property_name=_this.addquery.name : ''; //规格名称无数据时进行填充
						item.spec=='' ? item.spec=_this.addquery.spec : ''; //规格名称无数据时进行填充
						item.property_price=='' ? item.property_price=_this.addquery.sellprice : ''; //无销售金额时填充
						return false;
					}
				});
				if(hasproperty) return false;  //当前该sku已存在，无需重新添加
				
				//当前sku不存在，重新添加并且强制作为第一个规格
				var propertys=[];
				propertys.push({productid:this.addquery.productid,property_name:this.addquery.name,property_price:this.addquery.sellprice,
										specialprice:0,unitid:this.addquery.unitid,unit:this.addquery.unit,img:'',weight:'',
										isagent:0,cz_price:0,spec:this.addquery.spec,issplit:false,sku:this.addquery.spu,barcode:this.addquery.barcode,
										inventory:0,useinventory:0,lastinventory:0,first:1});
				this.addquery.property.forEach(function(item,ii) {propertys.push(item);});
				this.addquery.property=propertys; //替换新的规格信息
			}
		},

	    
				        
    }
}
</script>

<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.add-goods-new {float:left;width:100%;}
.add-goods-new .el-form-item__label {font-size:13px}
.add-goods-left {float:left;width:25%;border-right:1px dashed #999999;min-height:200px;}
.add-goods-right {float:left;width:72%;min-height:200px}
.add-jdgoods-label {float:left;width:100%}
.add-jdgoods-label-info {float:left;line-height:23px;color:#fff;font-weight:500px;padding:5px 10px;border-radius:15px;background:#F56C6C;font-size:12px;margin-bottom:20px}
.add-jdgoods-label-notice {float:left;font-size:13px;line-height:23px;color:#F56C6C}
.add-goods-cover-info-news {float:left;width:100%;padding:0 0 20px 0;position:relative;display:flex;align-items:center;}
.add-goods-cover-info-news-span {float:left;margin-right:2%;font-size:13px;line-height:23px;width:11%;}
.add-goods-cover-info-news-span i {font-style:normal;font-size:12px;color:#F56C6C;}
.add-goods-cover-info-news .add-goods-img-thumb {display:flex;align-items: center;justify-content: center;transition:.3s all;float:left;cursor:pointer;padding:3px;width:60px;height:60px;border-radius:15px;border:1px dashed #999999;background:rgba(221,221,221,.3);overflow:hidden}
.add-goods-cover-info-news .add-goods-img-thumb:hover {box-shadow:5px 5px 10px #666666}
.add-goods-cover-info-news .add-goods-img-thumb img {max-width:90%;max-height:90%;border-radius:6px}
.add-goods-img-lists {float:left;width:80%;border-radius:6px;padding:10px;transition:all .5s}
.add-goods-cover-info-news .add-goods-img-thumb1 {display:flex;align-items: center;justify-content: center;transition:.3s all;float:left;cursor:pointer;padding:3px;width:60px;height:60px;border-radius:15px;border:1px dashed #999999;background:rgba(221,221,221,.3);position:relative;margin:0 2% 10px 0}
.add-goods-cover-info-news .add-goods-img-thumb1:hover {box-shadow:5px 5px 10px #666666}
.add-goods-cover-info-news .add-goods-img-thumb1 img {max-width:90%;max-height:90%;border-radius:6px;width:''}
.add-goods-img-close {position:absolute;width:20px;height:20px;background:url(../../assets/error.png) no-repeat;background-size:20px 20px;margin:-65px 0 0 50px}
.add-goods-img-thumb1 .el-input {position:absolute;width:60px;margin-top:40px;background:rgba(0,0,0,.5);height:22px;border-radius:0 0 15px 15px}
.add-goods-img-thumb1 .el-input--mini .el-input__inner {background:none;border:none;font-weight:bold;color:#fff}
.add-goods-property-imgs {float:left;width:40px;height:40px;padding:5px;border-radius:6px;border:1px solid #dddddd;overflow:hidden;background:rgba(221,221,221,.3);display:flex;justify-content:center;align-items:center}
.add-goods-property-imgs img {max-width:90%;max-height:90%}
.add-goods-property-imgs:hover {cursor:pointer;}
.add-goods-packing {float:left;width:100%}
.add-goods-packing .specs {float:left;width:100%;margin-top:40px;font-size:1em;}
.add-goods-packing .specs .tdTitle {float:left;font-size:13px;padding:10px 0}
.showbigimg {display:flex;justify-content:center;align-items:center;position:fixed}

.goods-create-douyin-infos .el-form-item__label {font-size:13px}
.goods-create-douyin-infos {display:inline-block;width:100%;margin:40px 0 20px 0}
.goods-create-isdouyin-title {display:inline-block;width:100%;font-size:16px;font-weight:600;margin-bottom:20px}
.goods-create-isdouyin-title i {font-size:12px;font-style:normal;margin-left:1%;color:#555555}
.goods-create-isdouyin-select {display:inline-block;width:100%;margin:20px 0 0 0}
.goods-create-isdouyin-label {display:inline-block;font-size:13px}
.goods-create-isdouyin-btn {display:inline-block;margin-left:20px}
.goods-create-isdouyin-lists {display:inline-block;width:100%;padding:40px 0}
.goods-create-isdouyin-lists-info {display:inline-block;width:100%;padding:12px 0 0 0;border-top:1px dashed #fff;}
.goods-create-isdouyin-lists-left {float:left;width:10%}
.goods-create-isdouyin-dshop {width:100%;font-size:13px;line-height:23px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.goods-create-isdouyin-dshopid {width:100%;font-size:12px;line-height:23px;color:#999999;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.goods-create-isdouyin-lists-center {float:left;width:20%;padding:10px 25px;font-size:13px;border:1px dashed #999999;background:rgba(221,221,221,.3);border-radius:6px;position:relative;}
.goods-create-isdouyin-verify-success {position:absolute;width:25px;height:25px;padding:5px;border-radius:50%;line-height:14px;border:3px solid rgb(133, 206, 97);font-size:12px;color:rgb(133, 206, 97);font-weight:bold;display:flex;justify-content:center;align-items:center;text-align:center;top:-10px;left:-10px;background:#fff;transform:rotate(-45deg)}
.goods-create-isdouyin-verify-error {position:absolute;width:25px;height:25px;padding:5px;border-radius:50%;line-height:14px;border:3px solid #f78989;font-size:12px;color:#f78989;font-weight:bold;display:flex;justify-content:center;align-items:center;text-align:center;top:-10px;left:-10px;background:#fff;transform:rotate(-45deg)}
.goods-create-isdouyin-lists-right {float:left;width:calc(68% - 52px);margin-left:2%}
.goods-create-isdouyin-lists-info-item {float:left;width:30%;margin:10px 0;}
.goods-create-isdouyin-lists-info-itemtitles {float:left;font-size:13px;padding:0 10px;}
.goods-create-isdouyin-lists-info-itemcontent {float:left;max-width:70%}
.goods-create-isdouyin-lists-info-itemcontent-wid06 {float:left;max-width:60%}
.goods-create-isdouyin-lists-info-itemcontent-wid04 {float:left;max-width:40%}
.goods-create-isdouyin-question {padding:2px 4px;font-size:12px;line-height:12px;color:#fff;background:#E6A23C;border-radius:50%;margin-left:5px;}

.cz-mall-goods-mydrafs {position:fixed;width:20%;height:100%;z-index:1000;top:0;right:0;background:#F2F6FC;box-shadow:-2px 0 10px rgba(221,221,221,.5);transition:.5s all;margin-right:-20%;opacity:1;}
.cz-mall-goods-mydrafs-open {opacity:1;margin-right:0;}

.cz-mall-goods-btn {float:left;width:calc(100% - 40px);padding:0 20px;height:50px;display:flex;justify-content:left;align-items:center;}
.cz-mall-goods-nodrafs {float:left;width:100%;height:calc(100% - 50px);top:0;left:0;display:flex;justify-content:center;align-items:center;}
.cz-mall-goods-nodrafs-empty {width:50%}
.cz-mall-goods-nodrafs-empty img {float:left;width:50%;margin-left:25%}
.cz-mall-goods-nodrafs-empty span {color:#999999;font-size:14px;line-height:21px;float:left;width:100%;text-align:center;margin-top:10px;}

.cz-mall-goods-mydrafs-lists {float:left;width:calc(100% - 40px);padding:0 20px;height:calc(100% - 50px - 40px);margin-top:20px;overflow-x:hidden;overflow-y:auto;}
.cz-mall-goods-mydrafs-lists::-webkit-scrollbar {width:8px;height:8px;}
.cz-mall-goods-mydrafs-lists::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(220,223,230,0.2);background: rgba(96,98,102,0.4);}
.cz-mall-goods-mydrafs-lists::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}


.cz-mall-goods-mydrafs-infos {float:left;width:calc(100% - 40px);height:65px;padding:0 20px;display:flex;justify-content:left;align-items:center;border-bottom:1px solid #DCDFE6;cursor:pointer;transition:.3s all;}
.cz-mall-goods-mydrafs-infos:hover {background:#f56c6c;border-color:#f56c6c;border-radius:6px;}
.cz-mall-goods-mydrafs-infos:hover .name,.cz-mall-goods-mydrafs-infos:hover .time {color:#fff;}
.cz-mall-goods-mydrafs-infos:hover img {
	content:url('../../assets/drafs_white.png');
}

.cz-mall-goods-mydrafs-infos img {width:10%;}
.cz-mall-goods-mydrafs-infos-content {width:calc(100% - 10% - 10% - 8% - 2%);margin-left:10%;font-size:14px;line-height:21px;color:#666666;font-weight:400;}
.cz-mall-goods-mydrafs-infos-content .name {float:left;width:100%;font-size:13px;line-height:23px;color:#666666;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.cz-mall-goods-mydrafs-infos-content .time {float:left;width:100%;font-size:12px;line-height:23px;color:#999999;}

.cz-mall-goods-mydrafs-infos a {float:left;width:8%;margin-left:2%}
.cz-mall-goods-mydrafs-infos a img {float:left;width:100%}
.cz-mall-goods-mydrafs-infos:hover a img {
	content:url('../../assets/error_white.png');
}

.cz-mall-goods-add-show-loading {cursor:pointer;display:flex;justify-content:center;align-items:center;float:left;width:100%;height:60px;font-size:13px;color:#999999;}
.cz-mall-goods-add-show-loading .el-button {background:none;border:none;}

.unit-select-style {cursor:pointer;font-size:12px;color:#409EFF;}
</style>



// WEBPACK FOOTER //
// src/components/mall/Goodspushinfonew.vue